// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               v5.29.3
// source: enums.proto

/* eslint-disable */

export const protobufPackage = "raccoonai";

export enum TruckStatus {
  TRUCK_STATUS_UNDEFINED = "TRUCK_STATUS_UNDEFINED",
  TRUCK_STATUS_INACTIVE = "TRUCK_STATUS_INACTIVE",
  TRUCK_STATUS_ACTIVE = "TRUCK_STATUS_ACTIVE",
  TRUCK_STATUS_IN_REPAIR = "TRUCK_STATUS_IN_REPAIR",
  TRUCK_STATUS_GUEST = "TRUCK_STATUS_GUEST",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function truckStatusFromJSON(object: any): TruckStatus {
  switch (object) {
    case 0:
    case "TRUCK_STATUS_UNDEFINED":
      return TruckStatus.TRUCK_STATUS_UNDEFINED;
    case 1:
    case "TRUCK_STATUS_INACTIVE":
      return TruckStatus.TRUCK_STATUS_INACTIVE;
    case 2:
    case "TRUCK_STATUS_ACTIVE":
      return TruckStatus.TRUCK_STATUS_ACTIVE;
    case 3:
    case "TRUCK_STATUS_IN_REPAIR":
      return TruckStatus.TRUCK_STATUS_IN_REPAIR;
    case 4:
    case "TRUCK_STATUS_GUEST":
      return TruckStatus.TRUCK_STATUS_GUEST;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TruckStatus.UNRECOGNIZED;
  }
}

export function truckStatusToJSON(object: TruckStatus): string {
  switch (object) {
    case TruckStatus.TRUCK_STATUS_UNDEFINED:
      return "TRUCK_STATUS_UNDEFINED";
    case TruckStatus.TRUCK_STATUS_INACTIVE:
      return "TRUCK_STATUS_INACTIVE";
    case TruckStatus.TRUCK_STATUS_ACTIVE:
      return "TRUCK_STATUS_ACTIVE";
    case TruckStatus.TRUCK_STATUS_IN_REPAIR:
      return "TRUCK_STATUS_IN_REPAIR";
    case TruckStatus.TRUCK_STATUS_GUEST:
      return "TRUCK_STATUS_GUEST";
    case TruckStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function truckStatusToNumber(object: TruckStatus): number {
  switch (object) {
    case TruckStatus.TRUCK_STATUS_UNDEFINED:
      return 0;
    case TruckStatus.TRUCK_STATUS_INACTIVE:
      return 1;
    case TruckStatus.TRUCK_STATUS_ACTIVE:
      return 2;
    case TruckStatus.TRUCK_STATUS_IN_REPAIR:
      return 3;
    case TruckStatus.TRUCK_STATUS_GUEST:
      return 4;
    case TruckStatus.UNRECOGNIZED:
    default:
      return -1;
  }
}

export enum TruckType {
  TRUCK_TYPE_UNDEFINED = "TRUCK_TYPE_UNDEFINED",
  TRUCK_TYPE_CONSTRUCTION = "TRUCK_TYPE_CONSTRUCTION",
  /** TRUCK_TYPE_DOUBLE_CONTAINER - multilift */
  TRUCK_TYPE_DOUBLE_CONTAINER = "TRUCK_TYPE_DOUBLE_CONTAINER",
  TRUCK_TYPE_MSW = "TRUCK_TYPE_MSW",
  /** TRUCK_TYPE_TIPPER - samosval */
  TRUCK_TYPE_TIPPER = "TRUCK_TYPE_TIPPER",
  TRUCK_TYPE_LIQUID_WASTE = "TRUCK_TYPE_LIQUID_WASTE",
  /** TRUCK_TYPE_LOADER_CRANE - КМУ, кран-манипулятор */
  TRUCK_TYPE_LOADER_CRANE = "TRUCK_TYPE_LOADER_CRANE",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function truckTypeFromJSON(object: any): TruckType {
  switch (object) {
    case 0:
    case "TRUCK_TYPE_UNDEFINED":
      return TruckType.TRUCK_TYPE_UNDEFINED;
    case 1:
    case "TRUCK_TYPE_CONSTRUCTION":
      return TruckType.TRUCK_TYPE_CONSTRUCTION;
    case 2:
    case "TRUCK_TYPE_DOUBLE_CONTAINER":
      return TruckType.TRUCK_TYPE_DOUBLE_CONTAINER;
    case 3:
    case "TRUCK_TYPE_MSW":
      return TruckType.TRUCK_TYPE_MSW;
    case 4:
    case "TRUCK_TYPE_TIPPER":
      return TruckType.TRUCK_TYPE_TIPPER;
    case 5:
    case "TRUCK_TYPE_LIQUID_WASTE":
      return TruckType.TRUCK_TYPE_LIQUID_WASTE;
    case 6:
    case "TRUCK_TYPE_LOADER_CRANE":
      return TruckType.TRUCK_TYPE_LOADER_CRANE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TruckType.UNRECOGNIZED;
  }
}

export function truckTypeToJSON(object: TruckType): string {
  switch (object) {
    case TruckType.TRUCK_TYPE_UNDEFINED:
      return "TRUCK_TYPE_UNDEFINED";
    case TruckType.TRUCK_TYPE_CONSTRUCTION:
      return "TRUCK_TYPE_CONSTRUCTION";
    case TruckType.TRUCK_TYPE_DOUBLE_CONTAINER:
      return "TRUCK_TYPE_DOUBLE_CONTAINER";
    case TruckType.TRUCK_TYPE_MSW:
      return "TRUCK_TYPE_MSW";
    case TruckType.TRUCK_TYPE_TIPPER:
      return "TRUCK_TYPE_TIPPER";
    case TruckType.TRUCK_TYPE_LIQUID_WASTE:
      return "TRUCK_TYPE_LIQUID_WASTE";
    case TruckType.TRUCK_TYPE_LOADER_CRANE:
      return "TRUCK_TYPE_LOADER_CRANE";
    case TruckType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function truckTypeToNumber(object: TruckType): number {
  switch (object) {
    case TruckType.TRUCK_TYPE_UNDEFINED:
      return 0;
    case TruckType.TRUCK_TYPE_CONSTRUCTION:
      return 1;
    case TruckType.TRUCK_TYPE_DOUBLE_CONTAINER:
      return 2;
    case TruckType.TRUCK_TYPE_MSW:
      return 3;
    case TruckType.TRUCK_TYPE_TIPPER:
      return 4;
    case TruckType.TRUCK_TYPE_LIQUID_WASTE:
      return 5;
    case TruckType.TRUCK_TYPE_LOADER_CRANE:
      return 6;
    case TruckType.UNRECOGNIZED:
    default:
      return -1;
  }
}

export enum TruckLoadType {
  TRUCK_LOAD_TYPE_UNDEFINED = "TRUCK_LOAD_TYPE_UNDEFINED",
  TRUCK_LOAD_TYPE_FRONT = "TRUCK_LOAD_TYPE_FRONT",
  TRUCK_LOAD_TYPE_BACK = "TRUCK_LOAD_TYPE_BACK",
  TRUCK_LOAD_TYPE_SIDE = "TRUCK_LOAD_TYPE_SIDE",
  TRUCK_LOAD_TYPE_TOP = "TRUCK_LOAD_TYPE_TOP",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function truckLoadTypeFromJSON(object: any): TruckLoadType {
  switch (object) {
    case 0:
    case "TRUCK_LOAD_TYPE_UNDEFINED":
      return TruckLoadType.TRUCK_LOAD_TYPE_UNDEFINED;
    case 1:
    case "TRUCK_LOAD_TYPE_FRONT":
      return TruckLoadType.TRUCK_LOAD_TYPE_FRONT;
    case 2:
    case "TRUCK_LOAD_TYPE_BACK":
      return TruckLoadType.TRUCK_LOAD_TYPE_BACK;
    case 3:
    case "TRUCK_LOAD_TYPE_SIDE":
      return TruckLoadType.TRUCK_LOAD_TYPE_SIDE;
    case 4:
    case "TRUCK_LOAD_TYPE_TOP":
      return TruckLoadType.TRUCK_LOAD_TYPE_TOP;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TruckLoadType.UNRECOGNIZED;
  }
}

export function truckLoadTypeToJSON(object: TruckLoadType): string {
  switch (object) {
    case TruckLoadType.TRUCK_LOAD_TYPE_UNDEFINED:
      return "TRUCK_LOAD_TYPE_UNDEFINED";
    case TruckLoadType.TRUCK_LOAD_TYPE_FRONT:
      return "TRUCK_LOAD_TYPE_FRONT";
    case TruckLoadType.TRUCK_LOAD_TYPE_BACK:
      return "TRUCK_LOAD_TYPE_BACK";
    case TruckLoadType.TRUCK_LOAD_TYPE_SIDE:
      return "TRUCK_LOAD_TYPE_SIDE";
    case TruckLoadType.TRUCK_LOAD_TYPE_TOP:
      return "TRUCK_LOAD_TYPE_TOP";
    case TruckLoadType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function truckLoadTypeToNumber(object: TruckLoadType): number {
  switch (object) {
    case TruckLoadType.TRUCK_LOAD_TYPE_UNDEFINED:
      return 0;
    case TruckLoadType.TRUCK_LOAD_TYPE_FRONT:
      return 1;
    case TruckLoadType.TRUCK_LOAD_TYPE_BACK:
      return 2;
    case TruckLoadType.TRUCK_LOAD_TYPE_SIDE:
      return 3;
    case TruckLoadType.TRUCK_LOAD_TYPE_TOP:
      return 4;
    case TruckLoadType.UNRECOGNIZED:
    default:
      return -1;
  }
}

export enum TruckStandard {
  TRUCK_STANDARD_UNDEFINED = "TRUCK_STANDARD_UNDEFINED",
  TRUCK_STANDARD_EURO_1 = "TRUCK_STANDARD_EURO_1",
  TRUCK_STANDARD_EURO_2 = "TRUCK_STANDARD_EURO_2",
  TRUCK_STANDARD_EURO_3 = "TRUCK_STANDARD_EURO_3",
  TRUCK_STANDARD_EURO_4 = "TRUCK_STANDARD_EURO_4",
  TRUCK_STANDARD_EURO_5 = "TRUCK_STANDARD_EURO_5",
  TRUCK_STANDARD_EURO_6 = "TRUCK_STANDARD_EURO_6",
  TRUCK_STANDARD_EURO_7 = "TRUCK_STANDARD_EURO_7",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function truckStandardFromJSON(object: any): TruckStandard {
  switch (object) {
    case 0:
    case "TRUCK_STANDARD_UNDEFINED":
      return TruckStandard.TRUCK_STANDARD_UNDEFINED;
    case 1:
    case "TRUCK_STANDARD_EURO_1":
      return TruckStandard.TRUCK_STANDARD_EURO_1;
    case 2:
    case "TRUCK_STANDARD_EURO_2":
      return TruckStandard.TRUCK_STANDARD_EURO_2;
    case 3:
    case "TRUCK_STANDARD_EURO_3":
      return TruckStandard.TRUCK_STANDARD_EURO_3;
    case 4:
    case "TRUCK_STANDARD_EURO_4":
      return TruckStandard.TRUCK_STANDARD_EURO_4;
    case 5:
    case "TRUCK_STANDARD_EURO_5":
      return TruckStandard.TRUCK_STANDARD_EURO_5;
    case 6:
    case "TRUCK_STANDARD_EURO_6":
      return TruckStandard.TRUCK_STANDARD_EURO_6;
    case 7:
    case "TRUCK_STANDARD_EURO_7":
      return TruckStandard.TRUCK_STANDARD_EURO_7;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TruckStandard.UNRECOGNIZED;
  }
}

export function truckStandardToJSON(object: TruckStandard): string {
  switch (object) {
    case TruckStandard.TRUCK_STANDARD_UNDEFINED:
      return "TRUCK_STANDARD_UNDEFINED";
    case TruckStandard.TRUCK_STANDARD_EURO_1:
      return "TRUCK_STANDARD_EURO_1";
    case TruckStandard.TRUCK_STANDARD_EURO_2:
      return "TRUCK_STANDARD_EURO_2";
    case TruckStandard.TRUCK_STANDARD_EURO_3:
      return "TRUCK_STANDARD_EURO_3";
    case TruckStandard.TRUCK_STANDARD_EURO_4:
      return "TRUCK_STANDARD_EURO_4";
    case TruckStandard.TRUCK_STANDARD_EURO_5:
      return "TRUCK_STANDARD_EURO_5";
    case TruckStandard.TRUCK_STANDARD_EURO_6:
      return "TRUCK_STANDARD_EURO_6";
    case TruckStandard.TRUCK_STANDARD_EURO_7:
      return "TRUCK_STANDARD_EURO_7";
    case TruckStandard.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function truckStandardToNumber(object: TruckStandard): number {
  switch (object) {
    case TruckStandard.TRUCK_STANDARD_UNDEFINED:
      return 0;
    case TruckStandard.TRUCK_STANDARD_EURO_1:
      return 1;
    case TruckStandard.TRUCK_STANDARD_EURO_2:
      return 2;
    case TruckStandard.TRUCK_STANDARD_EURO_3:
      return 3;
    case TruckStandard.TRUCK_STANDARD_EURO_4:
      return 4;
    case TruckStandard.TRUCK_STANDARD_EURO_5:
      return 5;
    case TruckStandard.TRUCK_STANDARD_EURO_6:
      return 6;
    case TruckStandard.TRUCK_STANDARD_EURO_7:
      return 7;
    case TruckStandard.UNRECOGNIZED:
    default:
      return -1;
  }
}

export enum JobType {
  JOB_TYPE_UNDEFINED = "JOB_TYPE_UNDEFINED",
  /** JOB_TYPE_SERVICE - Core Bunker Operations */
  JOB_TYPE_SERVICE = "JOB_TYPE_SERVICE",
  /** JOB_TYPE_REPLACE_BUNKER - Забрать с заменой */
  JOB_TYPE_REPLACE_BUNKER = "JOB_TYPE_REPLACE_BUNKER",
  /** JOB_TYPE_ADD_BUNKER - Установить ёмкость */
  JOB_TYPE_ADD_BUNKER = "JOB_TYPE_ADD_BUNKER",
  /** JOB_TYPE_REMOVE_BUNKER - Забрать без замены */
  JOB_TYPE_REMOVE_BUNKER = "JOB_TYPE_REMOVE_BUNKER",
  /** JOB_TYPE_MSW - Municipal Solid Waste */
  JOB_TYPE_MSW = "JOB_TYPE_MSW",
  /** JOB_TYPE_MSW_CLEANUP - Подбор (Standard site cleanup) */
  JOB_TYPE_MSW_CLEANUP = "JOB_TYPE_MSW_CLEANUP",
  /** JOB_TYPE_MSW_MOBILE_CLEANUP - Подбор с объездом на ходу */
  JOB_TYPE_MSW_MOBILE_CLEANUP = "JOB_TYPE_MSW_MOBILE_CLEANUP",
  /** JOB_TYPE_DISINFECTION - Sanitation */
  JOB_TYPE_DISINFECTION = "JOB_TYPE_DISINFECTION",
  /** JOB_TYPE_TRANSPORTATION - Logistics */
  JOB_TYPE_TRANSPORTATION = "JOB_TYPE_TRANSPORTATION",
  /** JOB_TYPE_TRANSPORTATION_MPS - Перевозка (МПС - МПС) */
  JOB_TYPE_TRANSPORTATION_MPS = "JOB_TYPE_TRANSPORTATION_MPS",
  /** JOB_TYPE_BRAND_CONTAINER - Miscellaneous */
  JOB_TYPE_BRAND_CONTAINER = "JOB_TYPE_BRAND_CONTAINER",
  /** JOB_TYPE_REPAIR_CONTAINER - Ремонт ёмкости */
  JOB_TYPE_REPAIR_CONTAINER = "JOB_TYPE_REPAIR_CONTAINER",
  /** JOB_TYPE_DECOMMISSION_CONTAINER - Снять ёмкость */
  JOB_TYPE_DECOMMISSION_CONTAINER = "JOB_TYPE_DECOMMISSION_CONTAINER",
  /** JOB_TYPE_INSTALL_LID - Установить крышку */
  JOB_TYPE_INSTALL_LID = "JOB_TYPE_INSTALL_LID",
  /** JOB_TYPE_REMOVE_LID - Снять крышку */
  JOB_TYPE_REMOVE_LID = "JOB_TYPE_REMOVE_LID",
  /** JOB_TYPE_INSTALL_TAG - Установить идентификатор */
  JOB_TYPE_INSTALL_TAG = "JOB_TYPE_INSTALL_TAG",
  /** JOB_TYPE_LIQUID_WASTE - Liquid Waste */
  JOB_TYPE_LIQUID_WASTE = "JOB_TYPE_LIQUID_WASTE",
  /** JOB_TYPE_DOUBLE_CONSTRUCTION_REPLACE_BUNKER - Multilift */
  JOB_TYPE_DOUBLE_CONSTRUCTION_REPLACE_BUNKER = "JOB_TYPE_DOUBLE_CONSTRUCTION_REPLACE_BUNKER",
  JOB_TYPE_DOUBLE_CONSTRUCTION_ADD_BUNKER = "JOB_TYPE_DOUBLE_CONSTRUCTION_ADD_BUNKER",
  JOB_TYPE_DOUBLE_CONSTRUCTION_REMOVE_BUNKER = "JOB_TYPE_DOUBLE_CONSTRUCTION_REMOVE_BUNKER",
  /** JOB_TYPE_RECEIVE_LOAD - Bulk haul: a tipper sent alongside a loader crane takes what the crane loads */
  JOB_TYPE_RECEIVE_LOAD = "JOB_TYPE_RECEIVE_LOAD",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function jobTypeFromJSON(object: any): JobType {
  switch (object) {
    case 0:
    case "JOB_TYPE_UNDEFINED":
      return JobType.JOB_TYPE_UNDEFINED;
    case 1:
    case "JOB_TYPE_SERVICE":
      return JobType.JOB_TYPE_SERVICE;
    case 2:
    case "JOB_TYPE_REPLACE_BUNKER":
      return JobType.JOB_TYPE_REPLACE_BUNKER;
    case 3:
    case "JOB_TYPE_ADD_BUNKER":
      return JobType.JOB_TYPE_ADD_BUNKER;
    case 4:
    case "JOB_TYPE_REMOVE_BUNKER":
      return JobType.JOB_TYPE_REMOVE_BUNKER;
    case 10:
    case "JOB_TYPE_MSW":
      return JobType.JOB_TYPE_MSW;
    case 20:
    case "JOB_TYPE_MSW_CLEANUP":
      return JobType.JOB_TYPE_MSW_CLEANUP;
    case 21:
    case "JOB_TYPE_MSW_MOBILE_CLEANUP":
      return JobType.JOB_TYPE_MSW_MOBILE_CLEANUP;
    case 22:
    case "JOB_TYPE_DISINFECTION":
      return JobType.JOB_TYPE_DISINFECTION;
    case 30:
    case "JOB_TYPE_TRANSPORTATION":
      return JobType.JOB_TYPE_TRANSPORTATION;
    case 31:
    case "JOB_TYPE_TRANSPORTATION_MPS":
      return JobType.JOB_TYPE_TRANSPORTATION_MPS;
    case 40:
    case "JOB_TYPE_BRAND_CONTAINER":
      return JobType.JOB_TYPE_BRAND_CONTAINER;
    case 41:
    case "JOB_TYPE_REPAIR_CONTAINER":
      return JobType.JOB_TYPE_REPAIR_CONTAINER;
    case 42:
    case "JOB_TYPE_DECOMMISSION_CONTAINER":
      return JobType.JOB_TYPE_DECOMMISSION_CONTAINER;
    case 43:
    case "JOB_TYPE_INSTALL_LID":
      return JobType.JOB_TYPE_INSTALL_LID;
    case 44:
    case "JOB_TYPE_REMOVE_LID":
      return JobType.JOB_TYPE_REMOVE_LID;
    case 45:
    case "JOB_TYPE_INSTALL_TAG":
      return JobType.JOB_TYPE_INSTALL_TAG;
    case 50:
    case "JOB_TYPE_LIQUID_WASTE":
      return JobType.JOB_TYPE_LIQUID_WASTE;
    case 60:
    case "JOB_TYPE_DOUBLE_CONSTRUCTION_REPLACE_BUNKER":
      return JobType.JOB_TYPE_DOUBLE_CONSTRUCTION_REPLACE_BUNKER;
    case 61:
    case "JOB_TYPE_DOUBLE_CONSTRUCTION_ADD_BUNKER":
      return JobType.JOB_TYPE_DOUBLE_CONSTRUCTION_ADD_BUNKER;
    case 62:
    case "JOB_TYPE_DOUBLE_CONSTRUCTION_REMOVE_BUNKER":
      return JobType.JOB_TYPE_DOUBLE_CONSTRUCTION_REMOVE_BUNKER;
    case 70:
    case "JOB_TYPE_RECEIVE_LOAD":
      return JobType.JOB_TYPE_RECEIVE_LOAD;
    case -1:
    case "UNRECOGNIZED":
    default:
      return JobType.UNRECOGNIZED;
  }
}

export function jobTypeToJSON(object: JobType): string {
  switch (object) {
    case JobType.JOB_TYPE_UNDEFINED:
      return "JOB_TYPE_UNDEFINED";
    case JobType.JOB_TYPE_SERVICE:
      return "JOB_TYPE_SERVICE";
    case JobType.JOB_TYPE_REPLACE_BUNKER:
      return "JOB_TYPE_REPLACE_BUNKER";
    case JobType.JOB_TYPE_ADD_BUNKER:
      return "JOB_TYPE_ADD_BUNKER";
    case JobType.JOB_TYPE_REMOVE_BUNKER:
      return "JOB_TYPE_REMOVE_BUNKER";
    case JobType.JOB_TYPE_MSW:
      return "JOB_TYPE_MSW";
    case JobType.JOB_TYPE_MSW_CLEANUP:
      return "JOB_TYPE_MSW_CLEANUP";
    case JobType.JOB_TYPE_MSW_MOBILE_CLEANUP:
      return "JOB_TYPE_MSW_MOBILE_CLEANUP";
    case JobType.JOB_TYPE_DISINFECTION:
      return "JOB_TYPE_DISINFECTION";
    case JobType.JOB_TYPE_TRANSPORTATION:
      return "JOB_TYPE_TRANSPORTATION";
    case JobType.JOB_TYPE_TRANSPORTATION_MPS:
      return "JOB_TYPE_TRANSPORTATION_MPS";
    case JobType.JOB_TYPE_BRAND_CONTAINER:
      return "JOB_TYPE_BRAND_CONTAINER";
    case JobType.JOB_TYPE_REPAIR_CONTAINER:
      return "JOB_TYPE_REPAIR_CONTAINER";
    case JobType.JOB_TYPE_DECOMMISSION_CONTAINER:
      return "JOB_TYPE_DECOMMISSION_CONTAINER";
    case JobType.JOB_TYPE_INSTALL_LID:
      return "JOB_TYPE_INSTALL_LID";
    case JobType.JOB_TYPE_REMOVE_LID:
      return "JOB_TYPE_REMOVE_LID";
    case JobType.JOB_TYPE_INSTALL_TAG:
      return "JOB_TYPE_INSTALL_TAG";
    case JobType.JOB_TYPE_LIQUID_WASTE:
      return "JOB_TYPE_LIQUID_WASTE";
    case JobType.JOB_TYPE_DOUBLE_CONSTRUCTION_REPLACE_BUNKER:
      return "JOB_TYPE_DOUBLE_CONSTRUCTION_REPLACE_BUNKER";
    case JobType.JOB_TYPE_DOUBLE_CONSTRUCTION_ADD_BUNKER:
      return "JOB_TYPE_DOUBLE_CONSTRUCTION_ADD_BUNKER";
    case JobType.JOB_TYPE_DOUBLE_CONSTRUCTION_REMOVE_BUNKER:
      return "JOB_TYPE_DOUBLE_CONSTRUCTION_REMOVE_BUNKER";
    case JobType.JOB_TYPE_RECEIVE_LOAD:
      return "JOB_TYPE_RECEIVE_LOAD";
    case JobType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function jobTypeToNumber(object: JobType): number {
  switch (object) {
    case JobType.JOB_TYPE_UNDEFINED:
      return 0;
    case JobType.JOB_TYPE_SERVICE:
      return 1;
    case JobType.JOB_TYPE_REPLACE_BUNKER:
      return 2;
    case JobType.JOB_TYPE_ADD_BUNKER:
      return 3;
    case JobType.JOB_TYPE_REMOVE_BUNKER:
      return 4;
    case JobType.JOB_TYPE_MSW:
      return 10;
    case JobType.JOB_TYPE_MSW_CLEANUP:
      return 20;
    case JobType.JOB_TYPE_MSW_MOBILE_CLEANUP:
      return 21;
    case JobType.JOB_TYPE_DISINFECTION:
      return 22;
    case JobType.JOB_TYPE_TRANSPORTATION:
      return 30;
    case JobType.JOB_TYPE_TRANSPORTATION_MPS:
      return 31;
    case JobType.JOB_TYPE_BRAND_CONTAINER:
      return 40;
    case JobType.JOB_TYPE_REPAIR_CONTAINER:
      return 41;
    case JobType.JOB_TYPE_DECOMMISSION_CONTAINER:
      return 42;
    case JobType.JOB_TYPE_INSTALL_LID:
      return 43;
    case JobType.JOB_TYPE_REMOVE_LID:
      return 44;
    case JobType.JOB_TYPE_INSTALL_TAG:
      return 45;
    case JobType.JOB_TYPE_LIQUID_WASTE:
      return 50;
    case JobType.JOB_TYPE_DOUBLE_CONSTRUCTION_REPLACE_BUNKER:
      return 60;
    case JobType.JOB_TYPE_DOUBLE_CONSTRUCTION_ADD_BUNKER:
      return 61;
    case JobType.JOB_TYPE_DOUBLE_CONSTRUCTION_REMOVE_BUNKER:
      return 62;
    case JobType.JOB_TYPE_RECEIVE_LOAD:
      return 70;
    case JobType.UNRECOGNIZED:
    default:
      return -1;
  }
}

/** JobMetric selects which per-day job series GetJobMetricSeries returns. */
export enum JobMetric {
  JOB_METRIC_UNDEFINED = "JOB_METRIC_UNDEFINED",
  /** JOB_METRIC_REVENUE - SUM(job_tariff) of completed jobs, bucketed by completion day */
  JOB_METRIC_REVENUE = "JOB_METRIC_REVENUE",
  /** JOB_METRIC_ORDERED - COUNT of non-cancelled jobs, bucketed by created day */
  JOB_METRIC_ORDERED = "JOB_METRIC_ORDERED",
  /** JOB_METRIC_COMPLETED - COUNT of completed jobs, bucketed by completion day */
  JOB_METRIC_COMPLETED = "JOB_METRIC_COMPLETED",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function jobMetricFromJSON(object: any): JobMetric {
  switch (object) {
    case 0:
    case "JOB_METRIC_UNDEFINED":
      return JobMetric.JOB_METRIC_UNDEFINED;
    case 1:
    case "JOB_METRIC_REVENUE":
      return JobMetric.JOB_METRIC_REVENUE;
    case 2:
    case "JOB_METRIC_ORDERED":
      return JobMetric.JOB_METRIC_ORDERED;
    case 3:
    case "JOB_METRIC_COMPLETED":
      return JobMetric.JOB_METRIC_COMPLETED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return JobMetric.UNRECOGNIZED;
  }
}

export function jobMetricToJSON(object: JobMetric): string {
  switch (object) {
    case JobMetric.JOB_METRIC_UNDEFINED:
      return "JOB_METRIC_UNDEFINED";
    case JobMetric.JOB_METRIC_REVENUE:
      return "JOB_METRIC_REVENUE";
    case JobMetric.JOB_METRIC_ORDERED:
      return "JOB_METRIC_ORDERED";
    case JobMetric.JOB_METRIC_COMPLETED:
      return "JOB_METRIC_COMPLETED";
    case JobMetric.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function jobMetricToNumber(object: JobMetric): number {
  switch (object) {
    case JobMetric.JOB_METRIC_UNDEFINED:
      return 0;
    case JobMetric.JOB_METRIC_REVENUE:
      return 1;
    case JobMetric.JOB_METRIC_ORDERED:
      return 2;
    case JobMetric.JOB_METRIC_COMPLETED:
      return 3;
    case JobMetric.UNRECOGNIZED:
    default:
      return -1;
  }
}

/**
 * JobTotal keys a job list's "totals" facet: not a breakdown but what every job the
 * request matches adds up to — all of them, not one page; under one_per_order, each
 * order once. Facet counts are whole numbers, hence volume in litres.
 */
export enum JobTotal {
  JOB_TOTAL_UNDEFINED = "JOB_TOTAL_UNDEFINED",
  /** JOB_TOTAL_ORDERS - Orders: jobs sharing an order_number are one; a job without one is its own. */
  JOB_TOTAL_ORDERS = "JOB_TOTAL_ORDERS",
  JOB_TOTAL_PICKUP_LOCATIONS = "JOB_TOTAL_PICKUP_LOCATIONS",
  /** JOB_TOTAL_CONTAINERS - Planned containers: a job's own count, else its container group's. */
  JOB_TOTAL_CONTAINERS = "JOB_TOTAL_CONTAINERS",
  /**
   * JOB_TOTAL_VOLUME_LITRES - Planned volume, in litres (m³ × 1000, rounded): those containers × the volume of
   * their container group's type.
   */
  JOB_TOTAL_VOLUME_LITRES = "JOB_TOTAL_VOLUME_LITRES",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function jobTotalFromJSON(object: any): JobTotal {
  switch (object) {
    case 0:
    case "JOB_TOTAL_UNDEFINED":
      return JobTotal.JOB_TOTAL_UNDEFINED;
    case 1:
    case "JOB_TOTAL_ORDERS":
      return JobTotal.JOB_TOTAL_ORDERS;
    case 2:
    case "JOB_TOTAL_PICKUP_LOCATIONS":
      return JobTotal.JOB_TOTAL_PICKUP_LOCATIONS;
    case 3:
    case "JOB_TOTAL_CONTAINERS":
      return JobTotal.JOB_TOTAL_CONTAINERS;
    case 4:
    case "JOB_TOTAL_VOLUME_LITRES":
      return JobTotal.JOB_TOTAL_VOLUME_LITRES;
    case -1:
    case "UNRECOGNIZED":
    default:
      return JobTotal.UNRECOGNIZED;
  }
}

export function jobTotalToJSON(object: JobTotal): string {
  switch (object) {
    case JobTotal.JOB_TOTAL_UNDEFINED:
      return "JOB_TOTAL_UNDEFINED";
    case JobTotal.JOB_TOTAL_ORDERS:
      return "JOB_TOTAL_ORDERS";
    case JobTotal.JOB_TOTAL_PICKUP_LOCATIONS:
      return "JOB_TOTAL_PICKUP_LOCATIONS";
    case JobTotal.JOB_TOTAL_CONTAINERS:
      return "JOB_TOTAL_CONTAINERS";
    case JobTotal.JOB_TOTAL_VOLUME_LITRES:
      return "JOB_TOTAL_VOLUME_LITRES";
    case JobTotal.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function jobTotalToNumber(object: JobTotal): number {
  switch (object) {
    case JobTotal.JOB_TOTAL_UNDEFINED:
      return 0;
    case JobTotal.JOB_TOTAL_ORDERS:
      return 1;
    case JobTotal.JOB_TOTAL_PICKUP_LOCATIONS:
      return 2;
    case JobTotal.JOB_TOTAL_CONTAINERS:
      return 3;
    case JobTotal.JOB_TOTAL_VOLUME_LITRES:
      return 4;
    case JobTotal.UNRECOGNIZED:
    default:
      return -1;
  }
}

export enum DriverMetric {
  DRIVER_METRIC_UNDEFINED = "DRIVER_METRIC_UNDEFINED",
  DRIVER_METRIC_SHIFTS_COMPLETED = "DRIVER_METRIC_SHIFTS_COMPLETED",
  DRIVER_METRIC_ROUTES_COMPLETED = "DRIVER_METRIC_ROUTES_COMPLETED",
  DRIVER_METRIC_REWARD = "DRIVER_METRIC_REWARD",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function driverMetricFromJSON(object: any): DriverMetric {
  switch (object) {
    case 0:
    case "DRIVER_METRIC_UNDEFINED":
      return DriverMetric.DRIVER_METRIC_UNDEFINED;
    case 1:
    case "DRIVER_METRIC_SHIFTS_COMPLETED":
      return DriverMetric.DRIVER_METRIC_SHIFTS_COMPLETED;
    case 2:
    case "DRIVER_METRIC_ROUTES_COMPLETED":
      return DriverMetric.DRIVER_METRIC_ROUTES_COMPLETED;
    case 3:
    case "DRIVER_METRIC_REWARD":
      return DriverMetric.DRIVER_METRIC_REWARD;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DriverMetric.UNRECOGNIZED;
  }
}

export function driverMetricToJSON(object: DriverMetric): string {
  switch (object) {
    case DriverMetric.DRIVER_METRIC_UNDEFINED:
      return "DRIVER_METRIC_UNDEFINED";
    case DriverMetric.DRIVER_METRIC_SHIFTS_COMPLETED:
      return "DRIVER_METRIC_SHIFTS_COMPLETED";
    case DriverMetric.DRIVER_METRIC_ROUTES_COMPLETED:
      return "DRIVER_METRIC_ROUTES_COMPLETED";
    case DriverMetric.DRIVER_METRIC_REWARD:
      return "DRIVER_METRIC_REWARD";
    case DriverMetric.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function driverMetricToNumber(object: DriverMetric): number {
  switch (object) {
    case DriverMetric.DRIVER_METRIC_UNDEFINED:
      return 0;
    case DriverMetric.DRIVER_METRIC_SHIFTS_COMPLETED:
      return 1;
    case DriverMetric.DRIVER_METRIC_ROUTES_COMPLETED:
      return 2;
    case DriverMetric.DRIVER_METRIC_REWARD:
      return 3;
    case DriverMetric.UNRECOGNIZED:
    default:
      return -1;
  }
}

export enum JobCategory {
  JOB_CATEGORY_UNDEFINED = "JOB_CATEGORY_UNDEFINED",
  JOB_CATEGORY_CO = "JOB_CATEGORY_CO",
  JOB_CATEGORY_MSW = "JOB_CATEGORY_MSW",
  JOB_CATEGORY_LIQUID = "JOB_CATEGORY_LIQUID",
  JOB_CATEGORY_DISINFECTION = "JOB_CATEGORY_DISINFECTION",
  JOB_CATEGORY_TIPPER = "JOB_CATEGORY_TIPPER",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function jobCategoryFromJSON(object: any): JobCategory {
  switch (object) {
    case 0:
    case "JOB_CATEGORY_UNDEFINED":
      return JobCategory.JOB_CATEGORY_UNDEFINED;
    case 1:
    case "JOB_CATEGORY_CO":
      return JobCategory.JOB_CATEGORY_CO;
    case 2:
    case "JOB_CATEGORY_MSW":
      return JobCategory.JOB_CATEGORY_MSW;
    case 3:
    case "JOB_CATEGORY_LIQUID":
      return JobCategory.JOB_CATEGORY_LIQUID;
    case 4:
    case "JOB_CATEGORY_DISINFECTION":
      return JobCategory.JOB_CATEGORY_DISINFECTION;
    case 5:
    case "JOB_CATEGORY_TIPPER":
      return JobCategory.JOB_CATEGORY_TIPPER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return JobCategory.UNRECOGNIZED;
  }
}

export function jobCategoryToJSON(object: JobCategory): string {
  switch (object) {
    case JobCategory.JOB_CATEGORY_UNDEFINED:
      return "JOB_CATEGORY_UNDEFINED";
    case JobCategory.JOB_CATEGORY_CO:
      return "JOB_CATEGORY_CO";
    case JobCategory.JOB_CATEGORY_MSW:
      return "JOB_CATEGORY_MSW";
    case JobCategory.JOB_CATEGORY_LIQUID:
      return "JOB_CATEGORY_LIQUID";
    case JobCategory.JOB_CATEGORY_DISINFECTION:
      return "JOB_CATEGORY_DISINFECTION";
    case JobCategory.JOB_CATEGORY_TIPPER:
      return "JOB_CATEGORY_TIPPER";
    case JobCategory.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function jobCategoryToNumber(object: JobCategory): number {
  switch (object) {
    case JobCategory.JOB_CATEGORY_UNDEFINED:
      return 0;
    case JobCategory.JOB_CATEGORY_CO:
      return 1;
    case JobCategory.JOB_CATEGORY_MSW:
      return 2;
    case JobCategory.JOB_CATEGORY_LIQUID:
      return 3;
    case JobCategory.JOB_CATEGORY_DISINFECTION:
      return 4;
    case JobCategory.JOB_CATEGORY_TIPPER:
      return 5;
    case JobCategory.UNRECOGNIZED:
    default:
      return -1;
  }
}

export enum JobStatus {
  /** JOB_STATUS_UNDEFINED - Default value, should not be used. */
  JOB_STATUS_UNDEFINED = "JOB_STATUS_UNDEFINED",
  /** JOB_STATUS_CREATED - Marks jobs that are created but have not yet been assigned to any drivers. */
  JOB_STATUS_CREATED = "JOB_STATUS_CREATED",
  /** JOB_STATUS_ASSIGNED - Jobs that are assigned to drivers but have not yet going to the pickup location. */
  JOB_STATUS_ASSIGNED = "JOB_STATUS_ASSIGNED",
  /** JOB_STATUS_ENROUTE - Jobs that are assigned to drivers and are currently en-route to the pickup location. */
  JOB_STATUS_ENROUTE = "JOB_STATUS_ENROUTE",
  /** JOB_STATUS_COMPLETED - Marks jobs that are completed by the driver. */
  JOB_STATUS_COMPLETED = "JOB_STATUS_COMPLETED",
  /** JOB_STATUS_CANCELLED - Marks jobs that are cancelled by the dispatcher or client due to various reasons. */
  JOB_STATUS_CANCELLED = "JOB_STATUS_CANCELLED",
  /** JOB_STATUS_ON_SERVICE - Marks jobs that are currently being performed by the driver. */
  JOB_STATUS_ON_SERVICE = "JOB_STATUS_ON_SERVICE",
  /**
   * JOB_STATUS_FORCE_COMPLETED - Marks jobs that are force completed by dispatcher or system due to various reasons (e.g. driver
   * unable to complete the job due to safety issue, but the job is still considered completed for
   * record keeping and billing purposes).
   */
  JOB_STATUS_FORCE_COMPLETED = "JOB_STATUS_FORCE_COMPLETED",
  /**
   * JOB_STATUS_NOT_COMPLETED - Marks jobs that are could not be completed due to various reasons (e.g. truck is full, pickup
   * location is blocked). Jobs with this status are not considered completed, but the system will
   * automatically create a new job with the same details (i.e. pickup_location, order_number) for
   * someone to attempt again.
   */
  JOB_STATUS_NOT_COMPLETED = "JOB_STATUS_NOT_COMPLETED",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function jobStatusFromJSON(object: any): JobStatus {
  switch (object) {
    case 0:
    case "JOB_STATUS_UNDEFINED":
      return JobStatus.JOB_STATUS_UNDEFINED;
    case 1:
    case "JOB_STATUS_CREATED":
      return JobStatus.JOB_STATUS_CREATED;
    case 2:
    case "JOB_STATUS_ASSIGNED":
      return JobStatus.JOB_STATUS_ASSIGNED;
    case 3:
    case "JOB_STATUS_ENROUTE":
      return JobStatus.JOB_STATUS_ENROUTE;
    case 4:
    case "JOB_STATUS_COMPLETED":
      return JobStatus.JOB_STATUS_COMPLETED;
    case 5:
    case "JOB_STATUS_CANCELLED":
      return JobStatus.JOB_STATUS_CANCELLED;
    case 6:
    case "JOB_STATUS_ON_SERVICE":
      return JobStatus.JOB_STATUS_ON_SERVICE;
    case 7:
    case "JOB_STATUS_FORCE_COMPLETED":
      return JobStatus.JOB_STATUS_FORCE_COMPLETED;
    case 8:
    case "JOB_STATUS_NOT_COMPLETED":
      return JobStatus.JOB_STATUS_NOT_COMPLETED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return JobStatus.UNRECOGNIZED;
  }
}

export function jobStatusToJSON(object: JobStatus): string {
  switch (object) {
    case JobStatus.JOB_STATUS_UNDEFINED:
      return "JOB_STATUS_UNDEFINED";
    case JobStatus.JOB_STATUS_CREATED:
      return "JOB_STATUS_CREATED";
    case JobStatus.JOB_STATUS_ASSIGNED:
      return "JOB_STATUS_ASSIGNED";
    case JobStatus.JOB_STATUS_ENROUTE:
      return "JOB_STATUS_ENROUTE";
    case JobStatus.JOB_STATUS_COMPLETED:
      return "JOB_STATUS_COMPLETED";
    case JobStatus.JOB_STATUS_CANCELLED:
      return "JOB_STATUS_CANCELLED";
    case JobStatus.JOB_STATUS_ON_SERVICE:
      return "JOB_STATUS_ON_SERVICE";
    case JobStatus.JOB_STATUS_FORCE_COMPLETED:
      return "JOB_STATUS_FORCE_COMPLETED";
    case JobStatus.JOB_STATUS_NOT_COMPLETED:
      return "JOB_STATUS_NOT_COMPLETED";
    case JobStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function jobStatusToNumber(object: JobStatus): number {
  switch (object) {
    case JobStatus.JOB_STATUS_UNDEFINED:
      return 0;
    case JobStatus.JOB_STATUS_CREATED:
      return 1;
    case JobStatus.JOB_STATUS_ASSIGNED:
      return 2;
    case JobStatus.JOB_STATUS_ENROUTE:
      return 3;
    case JobStatus.JOB_STATUS_COMPLETED:
      return 4;
    case JobStatus.JOB_STATUS_CANCELLED:
      return 5;
    case JobStatus.JOB_STATUS_ON_SERVICE:
      return 6;
    case JobStatus.JOB_STATUS_FORCE_COMPLETED:
      return 7;
    case JobStatus.JOB_STATUS_NOT_COMPLETED:
      return 8;
    case JobStatus.UNRECOGNIZED:
    default:
      return -1;
  }
}

export enum DispatcherReviewStatus {
  DISPATCHER_REVIEW_STATUS_UNDEFINED = "DISPATCHER_REVIEW_STATUS_UNDEFINED",
  DISPATCHER_REVIEW_STATUS_PENDING = "DISPATCHER_REVIEW_STATUS_PENDING",
  DISPATCHER_REVIEW_STATUS_APPROVED = "DISPATCHER_REVIEW_STATUS_APPROVED",
  DISPATCHER_REVIEW_STATUS_REJECTED = "DISPATCHER_REVIEW_STATUS_REJECTED",
  DISPATCHER_REVIEW_STATUS_SUSPICIOUS = "DISPATCHER_REVIEW_STATUS_SUSPICIOUS",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function dispatcherReviewStatusFromJSON(object: any): DispatcherReviewStatus {
  switch (object) {
    case 0:
    case "DISPATCHER_REVIEW_STATUS_UNDEFINED":
      return DispatcherReviewStatus.DISPATCHER_REVIEW_STATUS_UNDEFINED;
    case 1:
    case "DISPATCHER_REVIEW_STATUS_PENDING":
      return DispatcherReviewStatus.DISPATCHER_REVIEW_STATUS_PENDING;
    case 2:
    case "DISPATCHER_REVIEW_STATUS_APPROVED":
      return DispatcherReviewStatus.DISPATCHER_REVIEW_STATUS_APPROVED;
    case 3:
    case "DISPATCHER_REVIEW_STATUS_REJECTED":
      return DispatcherReviewStatus.DISPATCHER_REVIEW_STATUS_REJECTED;
    case 4:
    case "DISPATCHER_REVIEW_STATUS_SUSPICIOUS":
      return DispatcherReviewStatus.DISPATCHER_REVIEW_STATUS_SUSPICIOUS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DispatcherReviewStatus.UNRECOGNIZED;
  }
}

export function dispatcherReviewStatusToJSON(object: DispatcherReviewStatus): string {
  switch (object) {
    case DispatcherReviewStatus.DISPATCHER_REVIEW_STATUS_UNDEFINED:
      return "DISPATCHER_REVIEW_STATUS_UNDEFINED";
    case DispatcherReviewStatus.DISPATCHER_REVIEW_STATUS_PENDING:
      return "DISPATCHER_REVIEW_STATUS_PENDING";
    case DispatcherReviewStatus.DISPATCHER_REVIEW_STATUS_APPROVED:
      return "DISPATCHER_REVIEW_STATUS_APPROVED";
    case DispatcherReviewStatus.DISPATCHER_REVIEW_STATUS_REJECTED:
      return "DISPATCHER_REVIEW_STATUS_REJECTED";
    case DispatcherReviewStatus.DISPATCHER_REVIEW_STATUS_SUSPICIOUS:
      return "DISPATCHER_REVIEW_STATUS_SUSPICIOUS";
    case DispatcherReviewStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function dispatcherReviewStatusToNumber(object: DispatcherReviewStatus): number {
  switch (object) {
    case DispatcherReviewStatus.DISPATCHER_REVIEW_STATUS_UNDEFINED:
      return 0;
    case DispatcherReviewStatus.DISPATCHER_REVIEW_STATUS_PENDING:
      return 1;
    case DispatcherReviewStatus.DISPATCHER_REVIEW_STATUS_APPROVED:
      return 2;
    case DispatcherReviewStatus.DISPATCHER_REVIEW_STATUS_REJECTED:
      return 3;
    case DispatcherReviewStatus.DISPATCHER_REVIEW_STATUS_SUSPICIOUS:
      return 4;
    case DispatcherReviewStatus.UNRECOGNIZED:
    default:
      return -1;
  }
}

export enum JobEvent {
  JOB_EVENT_UNDEFINED = "JOB_EVENT_UNDEFINED",
  JOB_EVENT_CREATE_JOB = "JOB_EVENT_CREATE_JOB",
  JOB_EVENT_ASSIGN = "JOB_EVENT_ASSIGN",
  JOB_EVENT_FALLBACK_ASSIGN = "JOB_EVENT_FALLBACK_ASSIGN",
  JOB_EVENT_ENROUTE = "JOB_EVENT_ENROUTE",
  JOB_EVENT_START_SERVICE = "JOB_EVENT_START_SERVICE",
  JOB_EVENT_COMPLETE = "JOB_EVENT_COMPLETE",
  JOB_EVENT_CANCEL = "JOB_EVENT_CANCEL",
  JOB_EVENT_DETACH_FROM_ROUTE = "JOB_EVENT_DETACH_FROM_ROUTE",
  JOB_EVENT_FORCE_COMPLETE = "JOB_EVENT_FORCE_COMPLETE",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function jobEventFromJSON(object: any): JobEvent {
  switch (object) {
    case 0:
    case "JOB_EVENT_UNDEFINED":
      return JobEvent.JOB_EVENT_UNDEFINED;
    case 1:
    case "JOB_EVENT_CREATE_JOB":
      return JobEvent.JOB_EVENT_CREATE_JOB;
    case 2:
    case "JOB_EVENT_ASSIGN":
      return JobEvent.JOB_EVENT_ASSIGN;
    case 3:
    case "JOB_EVENT_FALLBACK_ASSIGN":
      return JobEvent.JOB_EVENT_FALLBACK_ASSIGN;
    case 4:
    case "JOB_EVENT_ENROUTE":
      return JobEvent.JOB_EVENT_ENROUTE;
    case 5:
    case "JOB_EVENT_START_SERVICE":
      return JobEvent.JOB_EVENT_START_SERVICE;
    case 6:
    case "JOB_EVENT_COMPLETE":
      return JobEvent.JOB_EVENT_COMPLETE;
    case 7:
    case "JOB_EVENT_CANCEL":
      return JobEvent.JOB_EVENT_CANCEL;
    case 8:
    case "JOB_EVENT_DETACH_FROM_ROUTE":
      return JobEvent.JOB_EVENT_DETACH_FROM_ROUTE;
    case 9:
    case "JOB_EVENT_FORCE_COMPLETE":
      return JobEvent.JOB_EVENT_FORCE_COMPLETE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return JobEvent.UNRECOGNIZED;
  }
}

export function jobEventToJSON(object: JobEvent): string {
  switch (object) {
    case JobEvent.JOB_EVENT_UNDEFINED:
      return "JOB_EVENT_UNDEFINED";
    case JobEvent.JOB_EVENT_CREATE_JOB:
      return "JOB_EVENT_CREATE_JOB";
    case JobEvent.JOB_EVENT_ASSIGN:
      return "JOB_EVENT_ASSIGN";
    case JobEvent.JOB_EVENT_FALLBACK_ASSIGN:
      return "JOB_EVENT_FALLBACK_ASSIGN";
    case JobEvent.JOB_EVENT_ENROUTE:
      return "JOB_EVENT_ENROUTE";
    case JobEvent.JOB_EVENT_START_SERVICE:
      return "JOB_EVENT_START_SERVICE";
    case JobEvent.JOB_EVENT_COMPLETE:
      return "JOB_EVENT_COMPLETE";
    case JobEvent.JOB_EVENT_CANCEL:
      return "JOB_EVENT_CANCEL";
    case JobEvent.JOB_EVENT_DETACH_FROM_ROUTE:
      return "JOB_EVENT_DETACH_FROM_ROUTE";
    case JobEvent.JOB_EVENT_FORCE_COMPLETE:
      return "JOB_EVENT_FORCE_COMPLETE";
    case JobEvent.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function jobEventToNumber(object: JobEvent): number {
  switch (object) {
    case JobEvent.JOB_EVENT_UNDEFINED:
      return 0;
    case JobEvent.JOB_EVENT_CREATE_JOB:
      return 1;
    case JobEvent.JOB_EVENT_ASSIGN:
      return 2;
    case JobEvent.JOB_EVENT_FALLBACK_ASSIGN:
      return 3;
    case JobEvent.JOB_EVENT_ENROUTE:
      return 4;
    case JobEvent.JOB_EVENT_START_SERVICE:
      return 5;
    case JobEvent.JOB_EVENT_COMPLETE:
      return 6;
    case JobEvent.JOB_EVENT_CANCEL:
      return 7;
    case JobEvent.JOB_EVENT_DETACH_FROM_ROUTE:
      return 8;
    case JobEvent.JOB_EVENT_FORCE_COMPLETE:
      return 9;
    case JobEvent.UNRECOGNIZED:
    default:
      return -1;
  }
}

export enum RouteStatus {
  /** ROUTE_STATUS_UNDEFINED - Default value, should not be used. */
  ROUTE_STATUS_UNDEFINED = "ROUTE_STATUS_UNDEFINED",
  /** ROUTE_STATUS_CREATED - Marks routes that are created, assigned to driver, but have not yet been started by the driver. */
  ROUTE_STATUS_CREATED = "ROUTE_STATUS_CREATED",
  /** ROUTE_STATUS_IN_PROGRESS - Driver has started the route, but has not yet completed all jobs in the route. */
  ROUTE_STATUS_IN_PROGRESS = "ROUTE_STATUS_IN_PROGRESS",
  /**
   * ROUTE_STATUS_RETURNING - Driver has started the route and is currently en-route back to the depot.
   * If all jobs are completed, the route will automatically switch to RETURNING status.
   * If some jobs in the route are not completed due to various reasons (e.g. truck is full,
   * pickup location is blocked). Not completed jobs will be marked as NOT_COMPLETED,
   * which consequently trigger to create new jobs with same order information.
   */
  ROUTE_STATUS_RETURNING = "ROUTE_STATUS_RETURNING",
  /** ROUTE_STATUS_COMPLETED - Marks routes that are completed by the driver when arriving at the depot. */
  ROUTE_STATUS_COMPLETED = "ROUTE_STATUS_COMPLETED",
  /**
   * ROUTE_STATUS_CANCELLED - Jobs that are not completed will be marked as CANCELLED, but jobs that are already
   * completed will remain COMPLETED
   */
  ROUTE_STATUS_CANCELLED = "ROUTE_STATUS_CANCELLED",
  /**
   * ROUTE_STATUS_FORCE_COMPLETED - Marks all jobs in the route as FORCE_COMPLETED, regardless of their individual statuses.
   * Can be done only by dispatcher.
   */
  ROUTE_STATUS_FORCE_COMPLETED = "ROUTE_STATUS_FORCE_COMPLETED",
  /** ROUTE_STATUS_NOT_APPROVED - Marks Planned Routes for drivers but not Approved, can not be triggered by driver */
  ROUTE_STATUS_NOT_APPROVED = "ROUTE_STATUS_NOT_APPROVED",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function routeStatusFromJSON(object: any): RouteStatus {
  switch (object) {
    case 0:
    case "ROUTE_STATUS_UNDEFINED":
      return RouteStatus.ROUTE_STATUS_UNDEFINED;
    case 1:
    case "ROUTE_STATUS_CREATED":
      return RouteStatus.ROUTE_STATUS_CREATED;
    case 2:
    case "ROUTE_STATUS_IN_PROGRESS":
      return RouteStatus.ROUTE_STATUS_IN_PROGRESS;
    case 3:
    case "ROUTE_STATUS_RETURNING":
      return RouteStatus.ROUTE_STATUS_RETURNING;
    case 4:
    case "ROUTE_STATUS_COMPLETED":
      return RouteStatus.ROUTE_STATUS_COMPLETED;
    case 5:
    case "ROUTE_STATUS_CANCELLED":
      return RouteStatus.ROUTE_STATUS_CANCELLED;
    case 6:
    case "ROUTE_STATUS_FORCE_COMPLETED":
      return RouteStatus.ROUTE_STATUS_FORCE_COMPLETED;
    case 7:
    case "ROUTE_STATUS_NOT_APPROVED":
      return RouteStatus.ROUTE_STATUS_NOT_APPROVED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RouteStatus.UNRECOGNIZED;
  }
}

export function routeStatusToJSON(object: RouteStatus): string {
  switch (object) {
    case RouteStatus.ROUTE_STATUS_UNDEFINED:
      return "ROUTE_STATUS_UNDEFINED";
    case RouteStatus.ROUTE_STATUS_CREATED:
      return "ROUTE_STATUS_CREATED";
    case RouteStatus.ROUTE_STATUS_IN_PROGRESS:
      return "ROUTE_STATUS_IN_PROGRESS";
    case RouteStatus.ROUTE_STATUS_RETURNING:
      return "ROUTE_STATUS_RETURNING";
    case RouteStatus.ROUTE_STATUS_COMPLETED:
      return "ROUTE_STATUS_COMPLETED";
    case RouteStatus.ROUTE_STATUS_CANCELLED:
      return "ROUTE_STATUS_CANCELLED";
    case RouteStatus.ROUTE_STATUS_FORCE_COMPLETED:
      return "ROUTE_STATUS_FORCE_COMPLETED";
    case RouteStatus.ROUTE_STATUS_NOT_APPROVED:
      return "ROUTE_STATUS_NOT_APPROVED";
    case RouteStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function routeStatusToNumber(object: RouteStatus): number {
  switch (object) {
    case RouteStatus.ROUTE_STATUS_UNDEFINED:
      return 0;
    case RouteStatus.ROUTE_STATUS_CREATED:
      return 1;
    case RouteStatus.ROUTE_STATUS_IN_PROGRESS:
      return 2;
    case RouteStatus.ROUTE_STATUS_RETURNING:
      return 3;
    case RouteStatus.ROUTE_STATUS_COMPLETED:
      return 4;
    case RouteStatus.ROUTE_STATUS_CANCELLED:
      return 5;
    case RouteStatus.ROUTE_STATUS_FORCE_COMPLETED:
      return 6;
    case RouteStatus.ROUTE_STATUS_NOT_APPROVED:
      return 7;
    case RouteStatus.UNRECOGNIZED:
    default:
      return -1;
  }
}

export enum RouteCategory {
  ROUTE_CATEGORY_UNDEFINED = "ROUTE_CATEGORY_UNDEFINED",
  ROUTE_CATEGORY_CO = "ROUTE_CATEGORY_CO",
  ROUTE_CATEGORY_MSW = "ROUTE_CATEGORY_MSW",
  ROUTE_CATEGORY_LIQUID = "ROUTE_CATEGORY_LIQUID",
  ROUTE_CATEGORY_TIPPER = "ROUTE_CATEGORY_TIPPER",
  ROUTE_CATEGORY_DISINFECTION = "ROUTE_CATEGORY_DISINFECTION",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function routeCategoryFromJSON(object: any): RouteCategory {
  switch (object) {
    case 0:
    case "ROUTE_CATEGORY_UNDEFINED":
      return RouteCategory.ROUTE_CATEGORY_UNDEFINED;
    case 1:
    case "ROUTE_CATEGORY_CO":
      return RouteCategory.ROUTE_CATEGORY_CO;
    case 2:
    case "ROUTE_CATEGORY_MSW":
      return RouteCategory.ROUTE_CATEGORY_MSW;
    case 3:
    case "ROUTE_CATEGORY_LIQUID":
      return RouteCategory.ROUTE_CATEGORY_LIQUID;
    case 4:
    case "ROUTE_CATEGORY_TIPPER":
      return RouteCategory.ROUTE_CATEGORY_TIPPER;
    case 5:
    case "ROUTE_CATEGORY_DISINFECTION":
      return RouteCategory.ROUTE_CATEGORY_DISINFECTION;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RouteCategory.UNRECOGNIZED;
  }
}

export function routeCategoryToJSON(object: RouteCategory): string {
  switch (object) {
    case RouteCategory.ROUTE_CATEGORY_UNDEFINED:
      return "ROUTE_CATEGORY_UNDEFINED";
    case RouteCategory.ROUTE_CATEGORY_CO:
      return "ROUTE_CATEGORY_CO";
    case RouteCategory.ROUTE_CATEGORY_MSW:
      return "ROUTE_CATEGORY_MSW";
    case RouteCategory.ROUTE_CATEGORY_LIQUID:
      return "ROUTE_CATEGORY_LIQUID";
    case RouteCategory.ROUTE_CATEGORY_TIPPER:
      return "ROUTE_CATEGORY_TIPPER";
    case RouteCategory.ROUTE_CATEGORY_DISINFECTION:
      return "ROUTE_CATEGORY_DISINFECTION";
    case RouteCategory.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function routeCategoryToNumber(object: RouteCategory): number {
  switch (object) {
    case RouteCategory.ROUTE_CATEGORY_UNDEFINED:
      return 0;
    case RouteCategory.ROUTE_CATEGORY_CO:
      return 1;
    case RouteCategory.ROUTE_CATEGORY_MSW:
      return 2;
    case RouteCategory.ROUTE_CATEGORY_LIQUID:
      return 3;
    case RouteCategory.ROUTE_CATEGORY_TIPPER:
      return 4;
    case RouteCategory.ROUTE_CATEGORY_DISINFECTION:
      return 5;
    case RouteCategory.UNRECOGNIZED:
    default:
      return -1;
  }
}

export enum RouteEvent {
  ROUTE_EVENT_UNDEFINED = "ROUTE_EVENT_UNDEFINED",
  ROUTE_EVENT_CREATE_ROUTE = "ROUTE_EVENT_CREATE_ROUTE",
  ROUTE_EVENT_START = "ROUTE_EVENT_START",
  ROUTE_EVENT_RETURN_BACK = "ROUTE_EVENT_RETURN_BACK",
  ROUTE_EVENT_COMPLETE = "ROUTE_EVENT_COMPLETE",
  ROUTE_EVENT_CANCEL_ROUTE_DUE_RECEIVER_REASONS = "ROUTE_EVENT_CANCEL_ROUTE_DUE_RECEIVER_REASONS",
  ROUTE_EVENT_CANCEL_ROUTE_DUE_PROVIDER_REASONS = "ROUTE_EVENT_CANCEL_ROUTE_DUE_PROVIDER_REASONS",
  ROUTE_EVENT_FORCE_COMPLETE = "ROUTE_EVENT_FORCE_COMPLETE",
  ROUTE_EVENT_CREATE_ROUTE_BY_AI = "ROUTE_EVENT_CREATE_ROUTE_BY_AI",
  ROUTE_EVENT_UPDATE_JOBS = "ROUTE_EVENT_UPDATE_JOBS",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function routeEventFromJSON(object: any): RouteEvent {
  switch (object) {
    case 0:
    case "ROUTE_EVENT_UNDEFINED":
      return RouteEvent.ROUTE_EVENT_UNDEFINED;
    case 1:
    case "ROUTE_EVENT_CREATE_ROUTE":
      return RouteEvent.ROUTE_EVENT_CREATE_ROUTE;
    case 2:
    case "ROUTE_EVENT_START":
      return RouteEvent.ROUTE_EVENT_START;
    case 3:
    case "ROUTE_EVENT_RETURN_BACK":
      return RouteEvent.ROUTE_EVENT_RETURN_BACK;
    case 4:
    case "ROUTE_EVENT_COMPLETE":
      return RouteEvent.ROUTE_EVENT_COMPLETE;
    case 5:
    case "ROUTE_EVENT_CANCEL_ROUTE_DUE_RECEIVER_REASONS":
      return RouteEvent.ROUTE_EVENT_CANCEL_ROUTE_DUE_RECEIVER_REASONS;
    case 6:
    case "ROUTE_EVENT_CANCEL_ROUTE_DUE_PROVIDER_REASONS":
      return RouteEvent.ROUTE_EVENT_CANCEL_ROUTE_DUE_PROVIDER_REASONS;
    case 7:
    case "ROUTE_EVENT_FORCE_COMPLETE":
      return RouteEvent.ROUTE_EVENT_FORCE_COMPLETE;
    case 8:
    case "ROUTE_EVENT_CREATE_ROUTE_BY_AI":
      return RouteEvent.ROUTE_EVENT_CREATE_ROUTE_BY_AI;
    case 9:
    case "ROUTE_EVENT_UPDATE_JOBS":
      return RouteEvent.ROUTE_EVENT_UPDATE_JOBS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RouteEvent.UNRECOGNIZED;
  }
}

export function routeEventToJSON(object: RouteEvent): string {
  switch (object) {
    case RouteEvent.ROUTE_EVENT_UNDEFINED:
      return "ROUTE_EVENT_UNDEFINED";
    case RouteEvent.ROUTE_EVENT_CREATE_ROUTE:
      return "ROUTE_EVENT_CREATE_ROUTE";
    case RouteEvent.ROUTE_EVENT_START:
      return "ROUTE_EVENT_START";
    case RouteEvent.ROUTE_EVENT_RETURN_BACK:
      return "ROUTE_EVENT_RETURN_BACK";
    case RouteEvent.ROUTE_EVENT_COMPLETE:
      return "ROUTE_EVENT_COMPLETE";
    case RouteEvent.ROUTE_EVENT_CANCEL_ROUTE_DUE_RECEIVER_REASONS:
      return "ROUTE_EVENT_CANCEL_ROUTE_DUE_RECEIVER_REASONS";
    case RouteEvent.ROUTE_EVENT_CANCEL_ROUTE_DUE_PROVIDER_REASONS:
      return "ROUTE_EVENT_CANCEL_ROUTE_DUE_PROVIDER_REASONS";
    case RouteEvent.ROUTE_EVENT_FORCE_COMPLETE:
      return "ROUTE_EVENT_FORCE_COMPLETE";
    case RouteEvent.ROUTE_EVENT_CREATE_ROUTE_BY_AI:
      return "ROUTE_EVENT_CREATE_ROUTE_BY_AI";
    case RouteEvent.ROUTE_EVENT_UPDATE_JOBS:
      return "ROUTE_EVENT_UPDATE_JOBS";
    case RouteEvent.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function routeEventToNumber(object: RouteEvent): number {
  switch (object) {
    case RouteEvent.ROUTE_EVENT_UNDEFINED:
      return 0;
    case RouteEvent.ROUTE_EVENT_CREATE_ROUTE:
      return 1;
    case RouteEvent.ROUTE_EVENT_START:
      return 2;
    case RouteEvent.ROUTE_EVENT_RETURN_BACK:
      return 3;
    case RouteEvent.ROUTE_EVENT_COMPLETE:
      return 4;
    case RouteEvent.ROUTE_EVENT_CANCEL_ROUTE_DUE_RECEIVER_REASONS:
      return 5;
    case RouteEvent.ROUTE_EVENT_CANCEL_ROUTE_DUE_PROVIDER_REASONS:
      return 6;
    case RouteEvent.ROUTE_EVENT_FORCE_COMPLETE:
      return 7;
    case RouteEvent.ROUTE_EVENT_CREATE_ROUTE_BY_AI:
      return 8;
    case RouteEvent.ROUTE_EVENT_UPDATE_JOBS:
      return 9;
    case RouteEvent.UNRECOGNIZED:
    default:
      return -1;
  }
}

export enum DriverOnShiftStatus {
  DRIVER_ON_SHIFT_STATUS_UNDEFINED = "DRIVER_ON_SHIFT_STATUS_UNDEFINED",
  /** DRIVER_ON_SHIFT_STATUS_TRUCK_IDLE - To be deprecated */
  DRIVER_ON_SHIFT_STATUS_TRUCK_IDLE = "DRIVER_ON_SHIFT_STATUS_TRUCK_IDLE",
  DRIVER_ON_SHIFT_STATUS_DRIVER_IDLE = "DRIVER_ON_SHIFT_STATUS_DRIVER_IDLE",
  DRIVER_ON_SHIFT_STATUS_CONFIRMATION = "DRIVER_ON_SHIFT_STATUS_CONFIRMATION",
  DRIVER_ON_SHIFT_STATUS_ENROUTE = "DRIVER_ON_SHIFT_STATUS_ENROUTE",
  DRIVER_ON_SHIFT_STATUS_ON_SERVICE = "DRIVER_ON_SHIFT_STATUS_ON_SERVICE",
  /**
   * DRIVER_ON_SHIFT_STATUS_IDLE - Driver is on shift but has not yet started any route,
   * and is waiting for dispatcher's assignment.
   */
  DRIVER_ON_SHIFT_STATUS_IDLE = "DRIVER_ON_SHIFT_STATUS_IDLE",
  /**
   * DRIVER_ON_SHIFT_STATUS_ACTIVE - Driver is on shift and currently performing a route
   * assigned by dispatcher.
   */
  DRIVER_ON_SHIFT_STATUS_ACTIVE = "DRIVER_ON_SHIFT_STATUS_ACTIVE",
  /**
   * DRIVER_ON_SHIFT_STATUS_ENDED - Shift is ended, either by driver or dispatcher. Driver
   * is off shift and is not available for assignment.
   */
  DRIVER_ON_SHIFT_STATUS_ENDED = "DRIVER_ON_SHIFT_STATUS_ENDED",
  /** DRIVER_ON_SHIFT_STATUS_NOT_APPROVED - Unapproved Shift for driver, only to be approved by dispatcher */
  DRIVER_ON_SHIFT_STATUS_NOT_APPROVED = "DRIVER_ON_SHIFT_STATUS_NOT_APPROVED",
  /**
   * DRIVER_ON_SHIFT_STATUS_CANCELLED - Shift was called off by a dispatcher before any work happened, as opposed
   * to ENDED, which is a shift that ran and finished.
   */
  DRIVER_ON_SHIFT_STATUS_CANCELLED = "DRIVER_ON_SHIFT_STATUS_CANCELLED",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function driverOnShiftStatusFromJSON(object: any): DriverOnShiftStatus {
  switch (object) {
    case 0:
    case "DRIVER_ON_SHIFT_STATUS_UNDEFINED":
      return DriverOnShiftStatus.DRIVER_ON_SHIFT_STATUS_UNDEFINED;
    case 1:
    case "DRIVER_ON_SHIFT_STATUS_TRUCK_IDLE":
      return DriverOnShiftStatus.DRIVER_ON_SHIFT_STATUS_TRUCK_IDLE;
    case 2:
    case "DRIVER_ON_SHIFT_STATUS_DRIVER_IDLE":
      return DriverOnShiftStatus.DRIVER_ON_SHIFT_STATUS_DRIVER_IDLE;
    case 3:
    case "DRIVER_ON_SHIFT_STATUS_CONFIRMATION":
      return DriverOnShiftStatus.DRIVER_ON_SHIFT_STATUS_CONFIRMATION;
    case 4:
    case "DRIVER_ON_SHIFT_STATUS_ENROUTE":
      return DriverOnShiftStatus.DRIVER_ON_SHIFT_STATUS_ENROUTE;
    case 5:
    case "DRIVER_ON_SHIFT_STATUS_ON_SERVICE":
      return DriverOnShiftStatus.DRIVER_ON_SHIFT_STATUS_ON_SERVICE;
    case 10:
    case "DRIVER_ON_SHIFT_STATUS_IDLE":
      return DriverOnShiftStatus.DRIVER_ON_SHIFT_STATUS_IDLE;
    case 11:
    case "DRIVER_ON_SHIFT_STATUS_ACTIVE":
      return DriverOnShiftStatus.DRIVER_ON_SHIFT_STATUS_ACTIVE;
    case 12:
    case "DRIVER_ON_SHIFT_STATUS_ENDED":
      return DriverOnShiftStatus.DRIVER_ON_SHIFT_STATUS_ENDED;
    case 13:
    case "DRIVER_ON_SHIFT_STATUS_NOT_APPROVED":
      return DriverOnShiftStatus.DRIVER_ON_SHIFT_STATUS_NOT_APPROVED;
    case 14:
    case "DRIVER_ON_SHIFT_STATUS_CANCELLED":
      return DriverOnShiftStatus.DRIVER_ON_SHIFT_STATUS_CANCELLED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DriverOnShiftStatus.UNRECOGNIZED;
  }
}

export function driverOnShiftStatusToJSON(object: DriverOnShiftStatus): string {
  switch (object) {
    case DriverOnShiftStatus.DRIVER_ON_SHIFT_STATUS_UNDEFINED:
      return "DRIVER_ON_SHIFT_STATUS_UNDEFINED";
    case DriverOnShiftStatus.DRIVER_ON_SHIFT_STATUS_TRUCK_IDLE:
      return "DRIVER_ON_SHIFT_STATUS_TRUCK_IDLE";
    case DriverOnShiftStatus.DRIVER_ON_SHIFT_STATUS_DRIVER_IDLE:
      return "DRIVER_ON_SHIFT_STATUS_DRIVER_IDLE";
    case DriverOnShiftStatus.DRIVER_ON_SHIFT_STATUS_CONFIRMATION:
      return "DRIVER_ON_SHIFT_STATUS_CONFIRMATION";
    case DriverOnShiftStatus.DRIVER_ON_SHIFT_STATUS_ENROUTE:
      return "DRIVER_ON_SHIFT_STATUS_ENROUTE";
    case DriverOnShiftStatus.DRIVER_ON_SHIFT_STATUS_ON_SERVICE:
      return "DRIVER_ON_SHIFT_STATUS_ON_SERVICE";
    case DriverOnShiftStatus.DRIVER_ON_SHIFT_STATUS_IDLE:
      return "DRIVER_ON_SHIFT_STATUS_IDLE";
    case DriverOnShiftStatus.DRIVER_ON_SHIFT_STATUS_ACTIVE:
      return "DRIVER_ON_SHIFT_STATUS_ACTIVE";
    case DriverOnShiftStatus.DRIVER_ON_SHIFT_STATUS_ENDED:
      return "DRIVER_ON_SHIFT_STATUS_ENDED";
    case DriverOnShiftStatus.DRIVER_ON_SHIFT_STATUS_NOT_APPROVED:
      return "DRIVER_ON_SHIFT_STATUS_NOT_APPROVED";
    case DriverOnShiftStatus.DRIVER_ON_SHIFT_STATUS_CANCELLED:
      return "DRIVER_ON_SHIFT_STATUS_CANCELLED";
    case DriverOnShiftStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function driverOnShiftStatusToNumber(object: DriverOnShiftStatus): number {
  switch (object) {
    case DriverOnShiftStatus.DRIVER_ON_SHIFT_STATUS_UNDEFINED:
      return 0;
    case DriverOnShiftStatus.DRIVER_ON_SHIFT_STATUS_TRUCK_IDLE:
      return 1;
    case DriverOnShiftStatus.DRIVER_ON_SHIFT_STATUS_DRIVER_IDLE:
      return 2;
    case DriverOnShiftStatus.DRIVER_ON_SHIFT_STATUS_CONFIRMATION:
      return 3;
    case DriverOnShiftStatus.DRIVER_ON_SHIFT_STATUS_ENROUTE:
      return 4;
    case DriverOnShiftStatus.DRIVER_ON_SHIFT_STATUS_ON_SERVICE:
      return 5;
    case DriverOnShiftStatus.DRIVER_ON_SHIFT_STATUS_IDLE:
      return 10;
    case DriverOnShiftStatus.DRIVER_ON_SHIFT_STATUS_ACTIVE:
      return 11;
    case DriverOnShiftStatus.DRIVER_ON_SHIFT_STATUS_ENDED:
      return 12;
    case DriverOnShiftStatus.DRIVER_ON_SHIFT_STATUS_NOT_APPROVED:
      return 13;
    case DriverOnShiftStatus.DRIVER_ON_SHIFT_STATUS_CANCELLED:
      return 14;
    case DriverOnShiftStatus.UNRECOGNIZED:
    default:
      return -1;
  }
}

/**
 * Derived state of one cell in the driver shift schedule matrix
 * (ShiftPlanService.ListShiftSchedule). Computed server-side by merging
 * shift_plan and driver_on_shift for an Asia/Almaty calendar day; a
 * driver_on_shift record always wins over a plan for the same day.
 */
export enum ShiftCellState {
  SHIFT_CELL_STATE_UNDEFINED = "SHIFT_CELL_STATE_UNDEFINED",
  /** SHIFT_CELL_STATE_ENDED - Dark grey: driver_on_shift exists with status ENDED. */
  SHIFT_CELL_STATE_ENDED = "SHIFT_CELL_STATE_ENDED",
  /**
   * SHIFT_CELL_STATE_ACTIVE - Green: driver_on_shift exists with status ACTIVE (stale past
   * ACTIVE shifts intentionally stay green so dispatchers spot them).
   */
  SHIFT_CELL_STATE_ACTIVE = "SHIFT_CELL_STATE_ACTIVE",
  /**
   * SHIFT_CELL_STATE_NOT_STARTED - Dark blue: driver_on_shift exists but work has not started
   * (NOT_APPROVED or IDLE), day is today or later.
   */
  SHIFT_CELL_STATE_NOT_STARTED = "SHIFT_CELL_STATE_NOT_STARTED",
  /** SHIFT_CELL_STATE_PLANNED - Light blue: shift_plan exists, no driver_on_shift, day is today or later. */
  SHIFT_CELL_STATE_PLANNED = "SHIFT_CELL_STATE_PLANNED",
  /**
   * SHIFT_CELL_STATE_MISSED - Red: the day has passed and the driver never worked it — either a
   * shift_plan with no driver_on_shift, or a driver_on_shift that was never
   * started (NOT_APPROVED/IDLE). A no-show either way.
   * A DAY_OFF plan is never MISSED: not working was the plan.
   */
  SHIFT_CELL_STATE_MISSED = "SHIFT_CELL_STATE_MISSED",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function shiftCellStateFromJSON(object: any): ShiftCellState {
  switch (object) {
    case 0:
    case "SHIFT_CELL_STATE_UNDEFINED":
      return ShiftCellState.SHIFT_CELL_STATE_UNDEFINED;
    case 1:
    case "SHIFT_CELL_STATE_ENDED":
      return ShiftCellState.SHIFT_CELL_STATE_ENDED;
    case 2:
    case "SHIFT_CELL_STATE_ACTIVE":
      return ShiftCellState.SHIFT_CELL_STATE_ACTIVE;
    case 3:
    case "SHIFT_CELL_STATE_NOT_STARTED":
      return ShiftCellState.SHIFT_CELL_STATE_NOT_STARTED;
    case 4:
    case "SHIFT_CELL_STATE_PLANNED":
      return ShiftCellState.SHIFT_CELL_STATE_PLANNED;
    case 5:
    case "SHIFT_CELL_STATE_MISSED":
      return ShiftCellState.SHIFT_CELL_STATE_MISSED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ShiftCellState.UNRECOGNIZED;
  }
}

export function shiftCellStateToJSON(object: ShiftCellState): string {
  switch (object) {
    case ShiftCellState.SHIFT_CELL_STATE_UNDEFINED:
      return "SHIFT_CELL_STATE_UNDEFINED";
    case ShiftCellState.SHIFT_CELL_STATE_ENDED:
      return "SHIFT_CELL_STATE_ENDED";
    case ShiftCellState.SHIFT_CELL_STATE_ACTIVE:
      return "SHIFT_CELL_STATE_ACTIVE";
    case ShiftCellState.SHIFT_CELL_STATE_NOT_STARTED:
      return "SHIFT_CELL_STATE_NOT_STARTED";
    case ShiftCellState.SHIFT_CELL_STATE_PLANNED:
      return "SHIFT_CELL_STATE_PLANNED";
    case ShiftCellState.SHIFT_CELL_STATE_MISSED:
      return "SHIFT_CELL_STATE_MISSED";
    case ShiftCellState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function shiftCellStateToNumber(object: ShiftCellState): number {
  switch (object) {
    case ShiftCellState.SHIFT_CELL_STATE_UNDEFINED:
      return 0;
    case ShiftCellState.SHIFT_CELL_STATE_ENDED:
      return 1;
    case ShiftCellState.SHIFT_CELL_STATE_ACTIVE:
      return 2;
    case ShiftCellState.SHIFT_CELL_STATE_NOT_STARTED:
      return 3;
    case ShiftCellState.SHIFT_CELL_STATE_PLANNED:
      return 4;
    case ShiftCellState.SHIFT_CELL_STATE_MISSED:
      return 5;
    case ShiftCellState.UNRECOGNIZED:
    default:
      return -1;
  }
}

/** What a shift_plan row plans for; SHIFT_CELL_STATE stays the derived state. */
export enum ShiftPlanType {
  SHIFT_PLAN_TYPE_UNDEFINED = "SHIFT_PLAN_TYPE_UNDEFINED",
  SHIFT_PLAN_TYPE_DAY = "SHIFT_PLAN_TYPE_DAY",
  SHIFT_PLAN_TYPE_NIGHT = "SHIFT_PLAN_TYPE_NIGHT",
  SHIFT_PLAN_TYPE_DAY_OFF = "SHIFT_PLAN_TYPE_DAY_OFF",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function shiftPlanTypeFromJSON(object: any): ShiftPlanType {
  switch (object) {
    case 0:
    case "SHIFT_PLAN_TYPE_UNDEFINED":
      return ShiftPlanType.SHIFT_PLAN_TYPE_UNDEFINED;
    case 1:
    case "SHIFT_PLAN_TYPE_DAY":
      return ShiftPlanType.SHIFT_PLAN_TYPE_DAY;
    case 2:
    case "SHIFT_PLAN_TYPE_NIGHT":
      return ShiftPlanType.SHIFT_PLAN_TYPE_NIGHT;
    case 3:
    case "SHIFT_PLAN_TYPE_DAY_OFF":
      return ShiftPlanType.SHIFT_PLAN_TYPE_DAY_OFF;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ShiftPlanType.UNRECOGNIZED;
  }
}

export function shiftPlanTypeToJSON(object: ShiftPlanType): string {
  switch (object) {
    case ShiftPlanType.SHIFT_PLAN_TYPE_UNDEFINED:
      return "SHIFT_PLAN_TYPE_UNDEFINED";
    case ShiftPlanType.SHIFT_PLAN_TYPE_DAY:
      return "SHIFT_PLAN_TYPE_DAY";
    case ShiftPlanType.SHIFT_PLAN_TYPE_NIGHT:
      return "SHIFT_PLAN_TYPE_NIGHT";
    case ShiftPlanType.SHIFT_PLAN_TYPE_DAY_OFF:
      return "SHIFT_PLAN_TYPE_DAY_OFF";
    case ShiftPlanType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function shiftPlanTypeToNumber(object: ShiftPlanType): number {
  switch (object) {
    case ShiftPlanType.SHIFT_PLAN_TYPE_UNDEFINED:
      return 0;
    case ShiftPlanType.SHIFT_PLAN_TYPE_DAY:
      return 1;
    case ShiftPlanType.SHIFT_PLAN_TYPE_NIGHT:
      return 2;
    case ShiftPlanType.SHIFT_PLAN_TYPE_DAY_OFF:
      return 3;
    case ShiftPlanType.UNRECOGNIZED:
    default:
      return -1;
  }
}

/** To be deprecated */
export enum DriverOnShiftEvent {
  DRIVER_ON_SHIFT_EVENT_UNDEFINED = "DRIVER_ON_SHIFT_EVENT_UNDEFINED",
  DRIVER_ON_SHIFT_EVENT_CREATE_SHIFT = "DRIVER_ON_SHIFT_EVENT_CREATE_SHIFT",
  DRIVER_ON_SHIFT_EVENT_DRIVER_ONLINE = "DRIVER_ON_SHIFT_EVENT_DRIVER_ONLINE",
  DRIVER_ON_SHIFT_EVENT_DRIVER_OFFLINE = "DRIVER_ON_SHIFT_EVENT_DRIVER_OFFLINE",
  DRIVER_ON_SHIFT_EVENT_CONFIRMATION = "DRIVER_ON_SHIFT_EVENT_CONFIRMATION",
  DRIVER_ON_SHIFT_EVENT_START_ROUTE = "DRIVER_ON_SHIFT_EVENT_START_ROUTE",
  DRIVER_ON_SHIFT_EVENT_START_SERVICE = "DRIVER_ON_SHIFT_EVENT_START_SERVICE",
  DRIVER_ON_SHIFT_EVENT_END_SERVICE = "DRIVER_ON_SHIFT_EVENT_END_SERVICE",
  DRIVER_ON_SHIFT_EVENT_COMPLETE_ROUTE = "DRIVER_ON_SHIFT_EVENT_COMPLETE_ROUTE",
  DRIVER_ON_SHIFT_EVENT_CANCEL_ROUTE_DUE_RECEIVER_REASONS = "DRIVER_ON_SHIFT_EVENT_CANCEL_ROUTE_DUE_RECEIVER_REASONS",
  DRIVER_ON_SHIFT_EVENT_CANCEL_ROUTE_DUE_PROVIDER_REASONS = "DRIVER_ON_SHIFT_EVENT_CANCEL_ROUTE_DUE_PROVIDER_REASONS",
  DRIVER_ON_SHIFT_EVENT_COMPLETE_SHIFT = "DRIVER_ON_SHIFT_EVENT_COMPLETE_SHIFT",
  DRIVER_ON_SHIFT_EVENT_FORCE_COMPLETE_ROUTE = "DRIVER_ON_SHIFT_EVENT_FORCE_COMPLETE_ROUTE",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function driverOnShiftEventFromJSON(object: any): DriverOnShiftEvent {
  switch (object) {
    case 0:
    case "DRIVER_ON_SHIFT_EVENT_UNDEFINED":
      return DriverOnShiftEvent.DRIVER_ON_SHIFT_EVENT_UNDEFINED;
    case 1:
    case "DRIVER_ON_SHIFT_EVENT_CREATE_SHIFT":
      return DriverOnShiftEvent.DRIVER_ON_SHIFT_EVENT_CREATE_SHIFT;
    case 2:
    case "DRIVER_ON_SHIFT_EVENT_DRIVER_ONLINE":
      return DriverOnShiftEvent.DRIVER_ON_SHIFT_EVENT_DRIVER_ONLINE;
    case 3:
    case "DRIVER_ON_SHIFT_EVENT_DRIVER_OFFLINE":
      return DriverOnShiftEvent.DRIVER_ON_SHIFT_EVENT_DRIVER_OFFLINE;
    case 4:
    case "DRIVER_ON_SHIFT_EVENT_CONFIRMATION":
      return DriverOnShiftEvent.DRIVER_ON_SHIFT_EVENT_CONFIRMATION;
    case 5:
    case "DRIVER_ON_SHIFT_EVENT_START_ROUTE":
      return DriverOnShiftEvent.DRIVER_ON_SHIFT_EVENT_START_ROUTE;
    case 6:
    case "DRIVER_ON_SHIFT_EVENT_START_SERVICE":
      return DriverOnShiftEvent.DRIVER_ON_SHIFT_EVENT_START_SERVICE;
    case 7:
    case "DRIVER_ON_SHIFT_EVENT_END_SERVICE":
      return DriverOnShiftEvent.DRIVER_ON_SHIFT_EVENT_END_SERVICE;
    case 8:
    case "DRIVER_ON_SHIFT_EVENT_COMPLETE_ROUTE":
      return DriverOnShiftEvent.DRIVER_ON_SHIFT_EVENT_COMPLETE_ROUTE;
    case 9:
    case "DRIVER_ON_SHIFT_EVENT_CANCEL_ROUTE_DUE_RECEIVER_REASONS":
      return DriverOnShiftEvent.DRIVER_ON_SHIFT_EVENT_CANCEL_ROUTE_DUE_RECEIVER_REASONS;
    case 10:
    case "DRIVER_ON_SHIFT_EVENT_CANCEL_ROUTE_DUE_PROVIDER_REASONS":
      return DriverOnShiftEvent.DRIVER_ON_SHIFT_EVENT_CANCEL_ROUTE_DUE_PROVIDER_REASONS;
    case 11:
    case "DRIVER_ON_SHIFT_EVENT_COMPLETE_SHIFT":
      return DriverOnShiftEvent.DRIVER_ON_SHIFT_EVENT_COMPLETE_SHIFT;
    case 12:
    case "DRIVER_ON_SHIFT_EVENT_FORCE_COMPLETE_ROUTE":
      return DriverOnShiftEvent.DRIVER_ON_SHIFT_EVENT_FORCE_COMPLETE_ROUTE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DriverOnShiftEvent.UNRECOGNIZED;
  }
}

export function driverOnShiftEventToJSON(object: DriverOnShiftEvent): string {
  switch (object) {
    case DriverOnShiftEvent.DRIVER_ON_SHIFT_EVENT_UNDEFINED:
      return "DRIVER_ON_SHIFT_EVENT_UNDEFINED";
    case DriverOnShiftEvent.DRIVER_ON_SHIFT_EVENT_CREATE_SHIFT:
      return "DRIVER_ON_SHIFT_EVENT_CREATE_SHIFT";
    case DriverOnShiftEvent.DRIVER_ON_SHIFT_EVENT_DRIVER_ONLINE:
      return "DRIVER_ON_SHIFT_EVENT_DRIVER_ONLINE";
    case DriverOnShiftEvent.DRIVER_ON_SHIFT_EVENT_DRIVER_OFFLINE:
      return "DRIVER_ON_SHIFT_EVENT_DRIVER_OFFLINE";
    case DriverOnShiftEvent.DRIVER_ON_SHIFT_EVENT_CONFIRMATION:
      return "DRIVER_ON_SHIFT_EVENT_CONFIRMATION";
    case DriverOnShiftEvent.DRIVER_ON_SHIFT_EVENT_START_ROUTE:
      return "DRIVER_ON_SHIFT_EVENT_START_ROUTE";
    case DriverOnShiftEvent.DRIVER_ON_SHIFT_EVENT_START_SERVICE:
      return "DRIVER_ON_SHIFT_EVENT_START_SERVICE";
    case DriverOnShiftEvent.DRIVER_ON_SHIFT_EVENT_END_SERVICE:
      return "DRIVER_ON_SHIFT_EVENT_END_SERVICE";
    case DriverOnShiftEvent.DRIVER_ON_SHIFT_EVENT_COMPLETE_ROUTE:
      return "DRIVER_ON_SHIFT_EVENT_COMPLETE_ROUTE";
    case DriverOnShiftEvent.DRIVER_ON_SHIFT_EVENT_CANCEL_ROUTE_DUE_RECEIVER_REASONS:
      return "DRIVER_ON_SHIFT_EVENT_CANCEL_ROUTE_DUE_RECEIVER_REASONS";
    case DriverOnShiftEvent.DRIVER_ON_SHIFT_EVENT_CANCEL_ROUTE_DUE_PROVIDER_REASONS:
      return "DRIVER_ON_SHIFT_EVENT_CANCEL_ROUTE_DUE_PROVIDER_REASONS";
    case DriverOnShiftEvent.DRIVER_ON_SHIFT_EVENT_COMPLETE_SHIFT:
      return "DRIVER_ON_SHIFT_EVENT_COMPLETE_SHIFT";
    case DriverOnShiftEvent.DRIVER_ON_SHIFT_EVENT_FORCE_COMPLETE_ROUTE:
      return "DRIVER_ON_SHIFT_EVENT_FORCE_COMPLETE_ROUTE";
    case DriverOnShiftEvent.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function driverOnShiftEventToNumber(object: DriverOnShiftEvent): number {
  switch (object) {
    case DriverOnShiftEvent.DRIVER_ON_SHIFT_EVENT_UNDEFINED:
      return 0;
    case DriverOnShiftEvent.DRIVER_ON_SHIFT_EVENT_CREATE_SHIFT:
      return 1;
    case DriverOnShiftEvent.DRIVER_ON_SHIFT_EVENT_DRIVER_ONLINE:
      return 2;
    case DriverOnShiftEvent.DRIVER_ON_SHIFT_EVENT_DRIVER_OFFLINE:
      return 3;
    case DriverOnShiftEvent.DRIVER_ON_SHIFT_EVENT_CONFIRMATION:
      return 4;
    case DriverOnShiftEvent.DRIVER_ON_SHIFT_EVENT_START_ROUTE:
      return 5;
    case DriverOnShiftEvent.DRIVER_ON_SHIFT_EVENT_START_SERVICE:
      return 6;
    case DriverOnShiftEvent.DRIVER_ON_SHIFT_EVENT_END_SERVICE:
      return 7;
    case DriverOnShiftEvent.DRIVER_ON_SHIFT_EVENT_COMPLETE_ROUTE:
      return 8;
    case DriverOnShiftEvent.DRIVER_ON_SHIFT_EVENT_CANCEL_ROUTE_DUE_RECEIVER_REASONS:
      return 9;
    case DriverOnShiftEvent.DRIVER_ON_SHIFT_EVENT_CANCEL_ROUTE_DUE_PROVIDER_REASONS:
      return 10;
    case DriverOnShiftEvent.DRIVER_ON_SHIFT_EVENT_COMPLETE_SHIFT:
      return 11;
    case DriverOnShiftEvent.DRIVER_ON_SHIFT_EVENT_FORCE_COMPLETE_ROUTE:
      return 12;
    case DriverOnShiftEvent.UNRECOGNIZED:
    default:
      return -1;
  }
}

export enum OrganizationStatus {
  ORGANIZATION_STATUS_UNDEFINED = "ORGANIZATION_STATUS_UNDEFINED",
  ORGANIZATION_STATUS_INACTIVE = "ORGANIZATION_STATUS_INACTIVE",
  ORGANIZATION_STATUS_ACTIVE = "ORGANIZATION_STATUS_ACTIVE",
  ORGANIZATION_STATUS_GUEST = "ORGANIZATION_STATUS_GUEST",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function organizationStatusFromJSON(object: any): OrganizationStatus {
  switch (object) {
    case 0:
    case "ORGANIZATION_STATUS_UNDEFINED":
      return OrganizationStatus.ORGANIZATION_STATUS_UNDEFINED;
    case 1:
    case "ORGANIZATION_STATUS_INACTIVE":
      return OrganizationStatus.ORGANIZATION_STATUS_INACTIVE;
    case 2:
    case "ORGANIZATION_STATUS_ACTIVE":
      return OrganizationStatus.ORGANIZATION_STATUS_ACTIVE;
    case 3:
    case "ORGANIZATION_STATUS_GUEST":
      return OrganizationStatus.ORGANIZATION_STATUS_GUEST;
    case -1:
    case "UNRECOGNIZED":
    default:
      return OrganizationStatus.UNRECOGNIZED;
  }
}

export function organizationStatusToJSON(object: OrganizationStatus): string {
  switch (object) {
    case OrganizationStatus.ORGANIZATION_STATUS_UNDEFINED:
      return "ORGANIZATION_STATUS_UNDEFINED";
    case OrganizationStatus.ORGANIZATION_STATUS_INACTIVE:
      return "ORGANIZATION_STATUS_INACTIVE";
    case OrganizationStatus.ORGANIZATION_STATUS_ACTIVE:
      return "ORGANIZATION_STATUS_ACTIVE";
    case OrganizationStatus.ORGANIZATION_STATUS_GUEST:
      return "ORGANIZATION_STATUS_GUEST";
    case OrganizationStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function organizationStatusToNumber(object: OrganizationStatus): number {
  switch (object) {
    case OrganizationStatus.ORGANIZATION_STATUS_UNDEFINED:
      return 0;
    case OrganizationStatus.ORGANIZATION_STATUS_INACTIVE:
      return 1;
    case OrganizationStatus.ORGANIZATION_STATUS_ACTIVE:
      return 2;
    case OrganizationStatus.ORGANIZATION_STATUS_GUEST:
      return 3;
    case OrganizationStatus.UNRECOGNIZED:
    default:
      return -1;
  }
}

export enum OrganizationType {
  ORGANIZATION_TYPE_UNDEFINED = "ORGANIZATION_TYPE_UNDEFINED",
  ORGANIZATION_TYPE_RACCOONAI = "ORGANIZATION_TYPE_RACCOONAI",
  ORGANIZATION_TYPE_SERVICE_PROVIDER = "ORGANIZATION_TYPE_SERVICE_PROVIDER",
  ORGANIZATION_TYPE_SERVICE_RECEIVER = "ORGANIZATION_TYPE_SERVICE_RECEIVER",
  ORGANIZATION_TYPE_DISPOSAL_SITE_OPERATOR = "ORGANIZATION_TYPE_DISPOSAL_SITE_OPERATOR",
  ORGANIZATION_TYPE_GOVERNMENT = "ORGANIZATION_TYPE_GOVERNMENT",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function organizationTypeFromJSON(object: any): OrganizationType {
  switch (object) {
    case 0:
    case "ORGANIZATION_TYPE_UNDEFINED":
      return OrganizationType.ORGANIZATION_TYPE_UNDEFINED;
    case 1:
    case "ORGANIZATION_TYPE_RACCOONAI":
      return OrganizationType.ORGANIZATION_TYPE_RACCOONAI;
    case 2:
    case "ORGANIZATION_TYPE_SERVICE_PROVIDER":
      return OrganizationType.ORGANIZATION_TYPE_SERVICE_PROVIDER;
    case 3:
    case "ORGANIZATION_TYPE_SERVICE_RECEIVER":
      return OrganizationType.ORGANIZATION_TYPE_SERVICE_RECEIVER;
    case 4:
    case "ORGANIZATION_TYPE_DISPOSAL_SITE_OPERATOR":
      return OrganizationType.ORGANIZATION_TYPE_DISPOSAL_SITE_OPERATOR;
    case 5:
    case "ORGANIZATION_TYPE_GOVERNMENT":
      return OrganizationType.ORGANIZATION_TYPE_GOVERNMENT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return OrganizationType.UNRECOGNIZED;
  }
}

export function organizationTypeToJSON(object: OrganizationType): string {
  switch (object) {
    case OrganizationType.ORGANIZATION_TYPE_UNDEFINED:
      return "ORGANIZATION_TYPE_UNDEFINED";
    case OrganizationType.ORGANIZATION_TYPE_RACCOONAI:
      return "ORGANIZATION_TYPE_RACCOONAI";
    case OrganizationType.ORGANIZATION_TYPE_SERVICE_PROVIDER:
      return "ORGANIZATION_TYPE_SERVICE_PROVIDER";
    case OrganizationType.ORGANIZATION_TYPE_SERVICE_RECEIVER:
      return "ORGANIZATION_TYPE_SERVICE_RECEIVER";
    case OrganizationType.ORGANIZATION_TYPE_DISPOSAL_SITE_OPERATOR:
      return "ORGANIZATION_TYPE_DISPOSAL_SITE_OPERATOR";
    case OrganizationType.ORGANIZATION_TYPE_GOVERNMENT:
      return "ORGANIZATION_TYPE_GOVERNMENT";
    case OrganizationType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function organizationTypeToNumber(object: OrganizationType): number {
  switch (object) {
    case OrganizationType.ORGANIZATION_TYPE_UNDEFINED:
      return 0;
    case OrganizationType.ORGANIZATION_TYPE_RACCOONAI:
      return 1;
    case OrganizationType.ORGANIZATION_TYPE_SERVICE_PROVIDER:
      return 2;
    case OrganizationType.ORGANIZATION_TYPE_SERVICE_RECEIVER:
      return 3;
    case OrganizationType.ORGANIZATION_TYPE_DISPOSAL_SITE_OPERATOR:
      return 4;
    case OrganizationType.ORGANIZATION_TYPE_GOVERNMENT:
      return 5;
    case OrganizationType.UNRECOGNIZED:
    default:
      return -1;
  }
}

export enum UserRole {
  USER_ROLE_UNDEFINED = "USER_ROLE_UNDEFINED",
  USER_ROLE_ADMIN = "USER_ROLE_ADMIN",
  USER_ROLE_RECEIVER_USER = "USER_ROLE_RECEIVER_USER",
  USER_ROLE_DRIVER = "USER_ROLE_DRIVER",
  USER_ROLE_PROVIDER_DISPATCHER = "USER_ROLE_PROVIDER_DISPATCHER",
  USER_ROLE_SUPPORT = "USER_ROLE_SUPPORT",
  USER_ROLE_PROVIDER_OWNER = "USER_ROLE_PROVIDER_OWNER",
  USER_ROLE_DISPOSAL_SITE_OWNER = "USER_ROLE_DISPOSAL_SITE_OWNER",
  USER_ROLE_DISPOSAL_SITE_ECO_INSPECTOR = "USER_ROLE_DISPOSAL_SITE_ECO_INSPECTOR",
  USER_ROLE_GOVERNMENT_AUDITOR = "USER_ROLE_GOVERNMENT_AUDITOR",
  USER_ROLE_PROVIDER_MECHANIC = "USER_ROLE_PROVIDER_MECHANIC",
  USER_ROLE_GPS_INNER_SERVICE = "USER_ROLE_GPS_INNER_SERVICE",
  USER_ROLE_PROVIDER_OWNER_VIEW_ONLY = "USER_ROLE_PROVIDER_OWNER_VIEW_ONLY",
  USER_ROLE_PROVIDER_SALES = "USER_ROLE_PROVIDER_SALES",
  /**
   * USER_ROLE_GOVERNMENT_ECO - Government ecology officer who logs and reviews field situation reports
   * (GovSituationReportService). Distinct from the government auditor role.
   */
  USER_ROLE_GOVERNMENT_ECO = "USER_ROLE_GOVERNMENT_ECO",
  USER_ROLE_GOVERNMENT_AUDITOR_EDITOR = "USER_ROLE_GOVERNMENT_AUDITOR_EDITOR",
  USER_ROLE_PROVIDER_LOADER = "USER_ROLE_PROVIDER_LOADER",
  /**
   * USER_ROLE_DAAS_DISPATCHER - RaccoonAI's own dispatcher, dispatching on behalf of service-provider
   * companies that outsource dispatching to us (DaaS). Internal role.
   */
  USER_ROLE_DAAS_DISPATCHER = "USER_ROLE_DAAS_DISPATCHER",
  /**
   * USER_ROLE_INTEGRATION_1C - Technical user of a service provider's accounting system (1C). May call
   * Integration1CService only; its owner organization must be a service provider.
   */
  USER_ROLE_INTEGRATION_1C = "USER_ROLE_INTEGRATION_1C",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function userRoleFromJSON(object: any): UserRole {
  switch (object) {
    case 0:
    case "USER_ROLE_UNDEFINED":
      return UserRole.USER_ROLE_UNDEFINED;
    case 1:
    case "USER_ROLE_ADMIN":
      return UserRole.USER_ROLE_ADMIN;
    case 2:
    case "USER_ROLE_RECEIVER_USER":
      return UserRole.USER_ROLE_RECEIVER_USER;
    case 3:
    case "USER_ROLE_DRIVER":
      return UserRole.USER_ROLE_DRIVER;
    case 4:
    case "USER_ROLE_PROVIDER_DISPATCHER":
      return UserRole.USER_ROLE_PROVIDER_DISPATCHER;
    case 6:
    case "USER_ROLE_SUPPORT":
      return UserRole.USER_ROLE_SUPPORT;
    case 7:
    case "USER_ROLE_PROVIDER_OWNER":
      return UserRole.USER_ROLE_PROVIDER_OWNER;
    case 8:
    case "USER_ROLE_DISPOSAL_SITE_OWNER":
      return UserRole.USER_ROLE_DISPOSAL_SITE_OWNER;
    case 9:
    case "USER_ROLE_DISPOSAL_SITE_ECO_INSPECTOR":
      return UserRole.USER_ROLE_DISPOSAL_SITE_ECO_INSPECTOR;
    case 10:
    case "USER_ROLE_GOVERNMENT_AUDITOR":
      return UserRole.USER_ROLE_GOVERNMENT_AUDITOR;
    case 11:
    case "USER_ROLE_PROVIDER_MECHANIC":
      return UserRole.USER_ROLE_PROVIDER_MECHANIC;
    case 12:
    case "USER_ROLE_GPS_INNER_SERVICE":
      return UserRole.USER_ROLE_GPS_INNER_SERVICE;
    case 13:
    case "USER_ROLE_PROVIDER_OWNER_VIEW_ONLY":
      return UserRole.USER_ROLE_PROVIDER_OWNER_VIEW_ONLY;
    case 14:
    case "USER_ROLE_PROVIDER_SALES":
      return UserRole.USER_ROLE_PROVIDER_SALES;
    case 15:
    case "USER_ROLE_GOVERNMENT_ECO":
      return UserRole.USER_ROLE_GOVERNMENT_ECO;
    case 16:
    case "USER_ROLE_GOVERNMENT_AUDITOR_EDITOR":
      return UserRole.USER_ROLE_GOVERNMENT_AUDITOR_EDITOR;
    case 17:
    case "USER_ROLE_PROVIDER_LOADER":
      return UserRole.USER_ROLE_PROVIDER_LOADER;
    case 18:
    case "USER_ROLE_DAAS_DISPATCHER":
      return UserRole.USER_ROLE_DAAS_DISPATCHER;
    case 19:
    case "USER_ROLE_INTEGRATION_1C":
      return UserRole.USER_ROLE_INTEGRATION_1C;
    case -1:
    case "UNRECOGNIZED":
    default:
      return UserRole.UNRECOGNIZED;
  }
}

export function userRoleToJSON(object: UserRole): string {
  switch (object) {
    case UserRole.USER_ROLE_UNDEFINED:
      return "USER_ROLE_UNDEFINED";
    case UserRole.USER_ROLE_ADMIN:
      return "USER_ROLE_ADMIN";
    case UserRole.USER_ROLE_RECEIVER_USER:
      return "USER_ROLE_RECEIVER_USER";
    case UserRole.USER_ROLE_DRIVER:
      return "USER_ROLE_DRIVER";
    case UserRole.USER_ROLE_PROVIDER_DISPATCHER:
      return "USER_ROLE_PROVIDER_DISPATCHER";
    case UserRole.USER_ROLE_SUPPORT:
      return "USER_ROLE_SUPPORT";
    case UserRole.USER_ROLE_PROVIDER_OWNER:
      return "USER_ROLE_PROVIDER_OWNER";
    case UserRole.USER_ROLE_DISPOSAL_SITE_OWNER:
      return "USER_ROLE_DISPOSAL_SITE_OWNER";
    case UserRole.USER_ROLE_DISPOSAL_SITE_ECO_INSPECTOR:
      return "USER_ROLE_DISPOSAL_SITE_ECO_INSPECTOR";
    case UserRole.USER_ROLE_GOVERNMENT_AUDITOR:
      return "USER_ROLE_GOVERNMENT_AUDITOR";
    case UserRole.USER_ROLE_PROVIDER_MECHANIC:
      return "USER_ROLE_PROVIDER_MECHANIC";
    case UserRole.USER_ROLE_GPS_INNER_SERVICE:
      return "USER_ROLE_GPS_INNER_SERVICE";
    case UserRole.USER_ROLE_PROVIDER_OWNER_VIEW_ONLY:
      return "USER_ROLE_PROVIDER_OWNER_VIEW_ONLY";
    case UserRole.USER_ROLE_PROVIDER_SALES:
      return "USER_ROLE_PROVIDER_SALES";
    case UserRole.USER_ROLE_GOVERNMENT_ECO:
      return "USER_ROLE_GOVERNMENT_ECO";
    case UserRole.USER_ROLE_GOVERNMENT_AUDITOR_EDITOR:
      return "USER_ROLE_GOVERNMENT_AUDITOR_EDITOR";
    case UserRole.USER_ROLE_PROVIDER_LOADER:
      return "USER_ROLE_PROVIDER_LOADER";
    case UserRole.USER_ROLE_DAAS_DISPATCHER:
      return "USER_ROLE_DAAS_DISPATCHER";
    case UserRole.USER_ROLE_INTEGRATION_1C:
      return "USER_ROLE_INTEGRATION_1C";
    case UserRole.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function userRoleToNumber(object: UserRole): number {
  switch (object) {
    case UserRole.USER_ROLE_UNDEFINED:
      return 0;
    case UserRole.USER_ROLE_ADMIN:
      return 1;
    case UserRole.USER_ROLE_RECEIVER_USER:
      return 2;
    case UserRole.USER_ROLE_DRIVER:
      return 3;
    case UserRole.USER_ROLE_PROVIDER_DISPATCHER:
      return 4;
    case UserRole.USER_ROLE_SUPPORT:
      return 6;
    case UserRole.USER_ROLE_PROVIDER_OWNER:
      return 7;
    case UserRole.USER_ROLE_DISPOSAL_SITE_OWNER:
      return 8;
    case UserRole.USER_ROLE_DISPOSAL_SITE_ECO_INSPECTOR:
      return 9;
    case UserRole.USER_ROLE_GOVERNMENT_AUDITOR:
      return 10;
    case UserRole.USER_ROLE_PROVIDER_MECHANIC:
      return 11;
    case UserRole.USER_ROLE_GPS_INNER_SERVICE:
      return 12;
    case UserRole.USER_ROLE_PROVIDER_OWNER_VIEW_ONLY:
      return 13;
    case UserRole.USER_ROLE_PROVIDER_SALES:
      return 14;
    case UserRole.USER_ROLE_GOVERNMENT_ECO:
      return 15;
    case UserRole.USER_ROLE_GOVERNMENT_AUDITOR_EDITOR:
      return 16;
    case UserRole.USER_ROLE_PROVIDER_LOADER:
      return 17;
    case UserRole.USER_ROLE_DAAS_DISPATCHER:
      return 18;
    case UserRole.USER_ROLE_INTEGRATION_1C:
      return 19;
    case UserRole.UNRECOGNIZED:
    default:
      return -1;
  }
}

export enum UserStatus {
  USER_STATUS_UNDEFINED = "USER_STATUS_UNDEFINED",
  USER_STATUS_INACTIVE = "USER_STATUS_INACTIVE",
  USER_STATUS_ACTIVE = "USER_STATUS_ACTIVE",
  USER_STATUS_GUEST = "USER_STATUS_GUEST",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function userStatusFromJSON(object: any): UserStatus {
  switch (object) {
    case 0:
    case "USER_STATUS_UNDEFINED":
      return UserStatus.USER_STATUS_UNDEFINED;
    case 1:
    case "USER_STATUS_INACTIVE":
      return UserStatus.USER_STATUS_INACTIVE;
    case 2:
    case "USER_STATUS_ACTIVE":
      return UserStatus.USER_STATUS_ACTIVE;
    case 3:
    case "USER_STATUS_GUEST":
      return UserStatus.USER_STATUS_GUEST;
    case -1:
    case "UNRECOGNIZED":
    default:
      return UserStatus.UNRECOGNIZED;
  }
}

export function userStatusToJSON(object: UserStatus): string {
  switch (object) {
    case UserStatus.USER_STATUS_UNDEFINED:
      return "USER_STATUS_UNDEFINED";
    case UserStatus.USER_STATUS_INACTIVE:
      return "USER_STATUS_INACTIVE";
    case UserStatus.USER_STATUS_ACTIVE:
      return "USER_STATUS_ACTIVE";
    case UserStatus.USER_STATUS_GUEST:
      return "USER_STATUS_GUEST";
    case UserStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function userStatusToNumber(object: UserStatus): number {
  switch (object) {
    case UserStatus.USER_STATUS_UNDEFINED:
      return 0;
    case UserStatus.USER_STATUS_INACTIVE:
      return 1;
    case UserStatus.USER_STATUS_ACTIVE:
      return 2;
    case UserStatus.USER_STATUS_GUEST:
      return 3;
    case UserStatus.UNRECOGNIZED:
    default:
      return -1;
  }
}

export enum ContractStatus {
  CONTRACT_STATUS_UNDEFINED = "CONTRACT_STATUS_UNDEFINED",
  CONTRACT_STATUS_INACTIVE = "CONTRACT_STATUS_INACTIVE",
  CONTRACT_STATUS_ACTIVE = "CONTRACT_STATUS_ACTIVE",
  CONTRACT_STATUS_HIDDEN = "CONTRACT_STATUS_HIDDEN",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function contractStatusFromJSON(object: any): ContractStatus {
  switch (object) {
    case 0:
    case "CONTRACT_STATUS_UNDEFINED":
      return ContractStatus.CONTRACT_STATUS_UNDEFINED;
    case 1:
    case "CONTRACT_STATUS_INACTIVE":
      return ContractStatus.CONTRACT_STATUS_INACTIVE;
    case 2:
    case "CONTRACT_STATUS_ACTIVE":
      return ContractStatus.CONTRACT_STATUS_ACTIVE;
    case 3:
    case "CONTRACT_STATUS_HIDDEN":
      return ContractStatus.CONTRACT_STATUS_HIDDEN;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ContractStatus.UNRECOGNIZED;
  }
}

export function contractStatusToJSON(object: ContractStatus): string {
  switch (object) {
    case ContractStatus.CONTRACT_STATUS_UNDEFINED:
      return "CONTRACT_STATUS_UNDEFINED";
    case ContractStatus.CONTRACT_STATUS_INACTIVE:
      return "CONTRACT_STATUS_INACTIVE";
    case ContractStatus.CONTRACT_STATUS_ACTIVE:
      return "CONTRACT_STATUS_ACTIVE";
    case ContractStatus.CONTRACT_STATUS_HIDDEN:
      return "CONTRACT_STATUS_HIDDEN";
    case ContractStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function contractStatusToNumber(object: ContractStatus): number {
  switch (object) {
    case ContractStatus.CONTRACT_STATUS_UNDEFINED:
      return 0;
    case ContractStatus.CONTRACT_STATUS_INACTIVE:
      return 1;
    case ContractStatus.CONTRACT_STATUS_ACTIVE:
      return 2;
    case ContractStatus.CONTRACT_STATUS_HIDDEN:
      return 3;
    case ContractStatus.UNRECOGNIZED:
    default:
      return -1;
  }
}

export enum ContractType {
  CONTRACT_TYPE_UNDEFINED = "CONTRACT_TYPE_UNDEFINED",
  CONTRACT_TYPE_WASTE_OPERATOR = "CONTRACT_TYPE_WASTE_OPERATOR",
  CONTRACT_TYPE_WASTE_POLYGON = "CONTRACT_TYPE_WASTE_POLYGON",
  /**
   * CONTRACT_TYPE_BY_NORM - «По норме»: the client uses someone else's pickup location, orders nothing,
   * and pays a flat monthly_fee. Prices no job types.
   */
  CONTRACT_TYPE_BY_NORM = "CONTRACT_TYPE_BY_NORM",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function contractTypeFromJSON(object: any): ContractType {
  switch (object) {
    case 0:
    case "CONTRACT_TYPE_UNDEFINED":
      return ContractType.CONTRACT_TYPE_UNDEFINED;
    case 1:
    case "CONTRACT_TYPE_WASTE_OPERATOR":
      return ContractType.CONTRACT_TYPE_WASTE_OPERATOR;
    case 2:
    case "CONTRACT_TYPE_WASTE_POLYGON":
      return ContractType.CONTRACT_TYPE_WASTE_POLYGON;
    case 3:
    case "CONTRACT_TYPE_BY_NORM":
      return ContractType.CONTRACT_TYPE_BY_NORM;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ContractType.UNRECOGNIZED;
  }
}

export function contractTypeToJSON(object: ContractType): string {
  switch (object) {
    case ContractType.CONTRACT_TYPE_UNDEFINED:
      return "CONTRACT_TYPE_UNDEFINED";
    case ContractType.CONTRACT_TYPE_WASTE_OPERATOR:
      return "CONTRACT_TYPE_WASTE_OPERATOR";
    case ContractType.CONTRACT_TYPE_WASTE_POLYGON:
      return "CONTRACT_TYPE_WASTE_POLYGON";
    case ContractType.CONTRACT_TYPE_BY_NORM:
      return "CONTRACT_TYPE_BY_NORM";
    case ContractType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function contractTypeToNumber(object: ContractType): number {
  switch (object) {
    case ContractType.CONTRACT_TYPE_UNDEFINED:
      return 0;
    case ContractType.CONTRACT_TYPE_WASTE_OPERATOR:
      return 1;
    case ContractType.CONTRACT_TYPE_WASTE_POLYGON:
      return 2;
    case ContractType.CONTRACT_TYPE_BY_NORM:
      return 3;
    case ContractType.UNRECOGNIZED:
    default:
      return -1;
  }
}

export enum LocationStatus {
  LOCATION_STATUS_UNDEFINED = "LOCATION_STATUS_UNDEFINED",
  LOCATION_STATUS_INACTIVE = "LOCATION_STATUS_INACTIVE",
  LOCATION_STATUS_ACTIVE = "LOCATION_STATUS_ACTIVE",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function locationStatusFromJSON(object: any): LocationStatus {
  switch (object) {
    case 0:
    case "LOCATION_STATUS_UNDEFINED":
      return LocationStatus.LOCATION_STATUS_UNDEFINED;
    case 1:
    case "LOCATION_STATUS_INACTIVE":
      return LocationStatus.LOCATION_STATUS_INACTIVE;
    case 2:
    case "LOCATION_STATUS_ACTIVE":
      return LocationStatus.LOCATION_STATUS_ACTIVE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return LocationStatus.UNRECOGNIZED;
  }
}

export function locationStatusToJSON(object: LocationStatus): string {
  switch (object) {
    case LocationStatus.LOCATION_STATUS_UNDEFINED:
      return "LOCATION_STATUS_UNDEFINED";
    case LocationStatus.LOCATION_STATUS_INACTIVE:
      return "LOCATION_STATUS_INACTIVE";
    case LocationStatus.LOCATION_STATUS_ACTIVE:
      return "LOCATION_STATUS_ACTIVE";
    case LocationStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function locationStatusToNumber(object: LocationStatus): number {
  switch (object) {
    case LocationStatus.LOCATION_STATUS_UNDEFINED:
      return 0;
    case LocationStatus.LOCATION_STATUS_INACTIVE:
      return 1;
    case LocationStatus.LOCATION_STATUS_ACTIVE:
      return 2;
    case LocationStatus.UNRECOGNIZED:
    default:
      return -1;
  }
}

export enum LocationType {
  LOCATION_TYPE_UNDEFINED = "LOCATION_TYPE_UNDEFINED",
  LOCATION_TYPE_DEPOT = "LOCATION_TYPE_DEPOT",
  LOCATION_TYPE_DISPOSAL_SITE = "LOCATION_TYPE_DISPOSAL_SITE",
  LOCATION_TYPE_GAS_STATION = "LOCATION_TYPE_GAS_STATION",
  LOCATION_TYPE_SUSPICIOUS = "LOCATION_TYPE_SUSPICIOUS",
  /** LOCATION_TYPE_SORTING_COMPLEX - Waste Sorting Complex */
  LOCATION_TYPE_SORTING_COMPLEX = "LOCATION_TYPE_SORTING_COMPLEX",
  /** LOCATION_TYPE_PROCESSING_PLANT - Waste Processing Plant */
  LOCATION_TYPE_PROCESSING_PLANT = "LOCATION_TYPE_PROCESSING_PLANT",
  /** LOCATION_TYPE_TRANSFER_STATION - Waste Transfer Station */
  LOCATION_TYPE_TRANSFER_STATION = "LOCATION_TYPE_TRANSFER_STATION",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function locationTypeFromJSON(object: any): LocationType {
  switch (object) {
    case 0:
    case "LOCATION_TYPE_UNDEFINED":
      return LocationType.LOCATION_TYPE_UNDEFINED;
    case 1:
    case "LOCATION_TYPE_DEPOT":
      return LocationType.LOCATION_TYPE_DEPOT;
    case 2:
    case "LOCATION_TYPE_DISPOSAL_SITE":
      return LocationType.LOCATION_TYPE_DISPOSAL_SITE;
    case 3:
    case "LOCATION_TYPE_GAS_STATION":
      return LocationType.LOCATION_TYPE_GAS_STATION;
    case 4:
    case "LOCATION_TYPE_SUSPICIOUS":
      return LocationType.LOCATION_TYPE_SUSPICIOUS;
    case 5:
    case "LOCATION_TYPE_SORTING_COMPLEX":
      return LocationType.LOCATION_TYPE_SORTING_COMPLEX;
    case 6:
    case "LOCATION_TYPE_PROCESSING_PLANT":
      return LocationType.LOCATION_TYPE_PROCESSING_PLANT;
    case 7:
    case "LOCATION_TYPE_TRANSFER_STATION":
      return LocationType.LOCATION_TYPE_TRANSFER_STATION;
    case -1:
    case "UNRECOGNIZED":
    default:
      return LocationType.UNRECOGNIZED;
  }
}

export function locationTypeToJSON(object: LocationType): string {
  switch (object) {
    case LocationType.LOCATION_TYPE_UNDEFINED:
      return "LOCATION_TYPE_UNDEFINED";
    case LocationType.LOCATION_TYPE_DEPOT:
      return "LOCATION_TYPE_DEPOT";
    case LocationType.LOCATION_TYPE_DISPOSAL_SITE:
      return "LOCATION_TYPE_DISPOSAL_SITE";
    case LocationType.LOCATION_TYPE_GAS_STATION:
      return "LOCATION_TYPE_GAS_STATION";
    case LocationType.LOCATION_TYPE_SUSPICIOUS:
      return "LOCATION_TYPE_SUSPICIOUS";
    case LocationType.LOCATION_TYPE_SORTING_COMPLEX:
      return "LOCATION_TYPE_SORTING_COMPLEX";
    case LocationType.LOCATION_TYPE_PROCESSING_PLANT:
      return "LOCATION_TYPE_PROCESSING_PLANT";
    case LocationType.LOCATION_TYPE_TRANSFER_STATION:
      return "LOCATION_TYPE_TRANSFER_STATION";
    case LocationType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function locationTypeToNumber(object: LocationType): number {
  switch (object) {
    case LocationType.LOCATION_TYPE_UNDEFINED:
      return 0;
    case LocationType.LOCATION_TYPE_DEPOT:
      return 1;
    case LocationType.LOCATION_TYPE_DISPOSAL_SITE:
      return 2;
    case LocationType.LOCATION_TYPE_GAS_STATION:
      return 3;
    case LocationType.LOCATION_TYPE_SUSPICIOUS:
      return 4;
    case LocationType.LOCATION_TYPE_SORTING_COMPLEX:
      return 5;
    case LocationType.LOCATION_TYPE_PROCESSING_PLANT:
      return 6;
    case LocationType.LOCATION_TYPE_TRANSFER_STATION:
      return 7;
    case LocationType.UNRECOGNIZED:
    default:
      return -1;
  }
}

export enum PickupLocationType {
  PICKUP_LOCATION_TYPE_UNDEFINED = "PICKUP_LOCATION_TYPE_UNDEFINED",
  PICKUP_LOCATION_TYPE_CONSTRUCTION = "PICKUP_LOCATION_TYPE_CONSTRUCTION",
  PICKUP_LOCATION_TYPE_HOUSEHOLD = "PICKUP_LOCATION_TYPE_HOUSEHOLD",
  PICKUP_LOCATION_TYPE_SEPTIC = "PICKUP_LOCATION_TYPE_SEPTIC",
  PICKUP_LOCATION_TYPE_MULTILIFT = "PICKUP_LOCATION_TYPE_MULTILIFT",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function pickupLocationTypeFromJSON(object: any): PickupLocationType {
  switch (object) {
    case 0:
    case "PICKUP_LOCATION_TYPE_UNDEFINED":
      return PickupLocationType.PICKUP_LOCATION_TYPE_UNDEFINED;
    case 1:
    case "PICKUP_LOCATION_TYPE_CONSTRUCTION":
      return PickupLocationType.PICKUP_LOCATION_TYPE_CONSTRUCTION;
    case 2:
    case "PICKUP_LOCATION_TYPE_HOUSEHOLD":
      return PickupLocationType.PICKUP_LOCATION_TYPE_HOUSEHOLD;
    case 3:
    case "PICKUP_LOCATION_TYPE_SEPTIC":
      return PickupLocationType.PICKUP_LOCATION_TYPE_SEPTIC;
    case 4:
    case "PICKUP_LOCATION_TYPE_MULTILIFT":
      return PickupLocationType.PICKUP_LOCATION_TYPE_MULTILIFT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PickupLocationType.UNRECOGNIZED;
  }
}

export function pickupLocationTypeToJSON(object: PickupLocationType): string {
  switch (object) {
    case PickupLocationType.PICKUP_LOCATION_TYPE_UNDEFINED:
      return "PICKUP_LOCATION_TYPE_UNDEFINED";
    case PickupLocationType.PICKUP_LOCATION_TYPE_CONSTRUCTION:
      return "PICKUP_LOCATION_TYPE_CONSTRUCTION";
    case PickupLocationType.PICKUP_LOCATION_TYPE_HOUSEHOLD:
      return "PICKUP_LOCATION_TYPE_HOUSEHOLD";
    case PickupLocationType.PICKUP_LOCATION_TYPE_SEPTIC:
      return "PICKUP_LOCATION_TYPE_SEPTIC";
    case PickupLocationType.PICKUP_LOCATION_TYPE_MULTILIFT:
      return "PICKUP_LOCATION_TYPE_MULTILIFT";
    case PickupLocationType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function pickupLocationTypeToNumber(object: PickupLocationType): number {
  switch (object) {
    case PickupLocationType.PICKUP_LOCATION_TYPE_UNDEFINED:
      return 0;
    case PickupLocationType.PICKUP_LOCATION_TYPE_CONSTRUCTION:
      return 1;
    case PickupLocationType.PICKUP_LOCATION_TYPE_HOUSEHOLD:
      return 2;
    case PickupLocationType.PICKUP_LOCATION_TYPE_SEPTIC:
      return 3;
    case PickupLocationType.PICKUP_LOCATION_TYPE_MULTILIFT:
      return 4;
    case PickupLocationType.UNRECOGNIZED:
    default:
      return -1;
  }
}

export enum PickupLocationPriority {
  PICKUP_LOCATION_PRIORITY_UNDEFINED = "PICKUP_LOCATION_PRIORITY_UNDEFINED",
  PICKUP_LOCATION_PRIORITY_LOW = "PICKUP_LOCATION_PRIORITY_LOW",
  PICKUP_LOCATION_PRIORITY_MEDIUM = "PICKUP_LOCATION_PRIORITY_MEDIUM",
  PICKUP_LOCATION_PRIORITY_HIGH = "PICKUP_LOCATION_PRIORITY_HIGH",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function pickupLocationPriorityFromJSON(object: any): PickupLocationPriority {
  switch (object) {
    case 0:
    case "PICKUP_LOCATION_PRIORITY_UNDEFINED":
      return PickupLocationPriority.PICKUP_LOCATION_PRIORITY_UNDEFINED;
    case 1:
    case "PICKUP_LOCATION_PRIORITY_LOW":
      return PickupLocationPriority.PICKUP_LOCATION_PRIORITY_LOW;
    case 2:
    case "PICKUP_LOCATION_PRIORITY_MEDIUM":
      return PickupLocationPriority.PICKUP_LOCATION_PRIORITY_MEDIUM;
    case 3:
    case "PICKUP_LOCATION_PRIORITY_HIGH":
      return PickupLocationPriority.PICKUP_LOCATION_PRIORITY_HIGH;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PickupLocationPriority.UNRECOGNIZED;
  }
}

export function pickupLocationPriorityToJSON(object: PickupLocationPriority): string {
  switch (object) {
    case PickupLocationPriority.PICKUP_LOCATION_PRIORITY_UNDEFINED:
      return "PICKUP_LOCATION_PRIORITY_UNDEFINED";
    case PickupLocationPriority.PICKUP_LOCATION_PRIORITY_LOW:
      return "PICKUP_LOCATION_PRIORITY_LOW";
    case PickupLocationPriority.PICKUP_LOCATION_PRIORITY_MEDIUM:
      return "PICKUP_LOCATION_PRIORITY_MEDIUM";
    case PickupLocationPriority.PICKUP_LOCATION_PRIORITY_HIGH:
      return "PICKUP_LOCATION_PRIORITY_HIGH";
    case PickupLocationPriority.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function pickupLocationPriorityToNumber(object: PickupLocationPriority): number {
  switch (object) {
    case PickupLocationPriority.PICKUP_LOCATION_PRIORITY_UNDEFINED:
      return 0;
    case PickupLocationPriority.PICKUP_LOCATION_PRIORITY_LOW:
      return 1;
    case PickupLocationPriority.PICKUP_LOCATION_PRIORITY_MEDIUM:
      return 2;
    case PickupLocationPriority.PICKUP_LOCATION_PRIORITY_HIGH:
      return 3;
    case PickupLocationPriority.UNRECOGNIZED:
    default:
      return -1;
  }
}

export enum ContainerTypeStatus {
  CONTAINER_TYPE_STATUS_UNDEFINED = "CONTAINER_TYPE_STATUS_UNDEFINED",
  /** CONTAINER_TYPE_STATUS_INACTIVE - Hidden from pickers for new container groups/containers; existing ones keep it. */
  CONTAINER_TYPE_STATUS_INACTIVE = "CONTAINER_TYPE_STATUS_INACTIVE",
  CONTAINER_TYPE_STATUS_ACTIVE = "CONTAINER_TYPE_STATUS_ACTIVE",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function containerTypeStatusFromJSON(object: any): ContainerTypeStatus {
  switch (object) {
    case 0:
    case "CONTAINER_TYPE_STATUS_UNDEFINED":
      return ContainerTypeStatus.CONTAINER_TYPE_STATUS_UNDEFINED;
    case 1:
    case "CONTAINER_TYPE_STATUS_INACTIVE":
      return ContainerTypeStatus.CONTAINER_TYPE_STATUS_INACTIVE;
    case 2:
    case "CONTAINER_TYPE_STATUS_ACTIVE":
      return ContainerTypeStatus.CONTAINER_TYPE_STATUS_ACTIVE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ContainerTypeStatus.UNRECOGNIZED;
  }
}

export function containerTypeStatusToJSON(object: ContainerTypeStatus): string {
  switch (object) {
    case ContainerTypeStatus.CONTAINER_TYPE_STATUS_UNDEFINED:
      return "CONTAINER_TYPE_STATUS_UNDEFINED";
    case ContainerTypeStatus.CONTAINER_TYPE_STATUS_INACTIVE:
      return "CONTAINER_TYPE_STATUS_INACTIVE";
    case ContainerTypeStatus.CONTAINER_TYPE_STATUS_ACTIVE:
      return "CONTAINER_TYPE_STATUS_ACTIVE";
    case ContainerTypeStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function containerTypeStatusToNumber(object: ContainerTypeStatus): number {
  switch (object) {
    case ContainerTypeStatus.CONTAINER_TYPE_STATUS_UNDEFINED:
      return 0;
    case ContainerTypeStatus.CONTAINER_TYPE_STATUS_INACTIVE:
      return 1;
    case ContainerTypeStatus.CONTAINER_TYPE_STATUS_ACTIVE:
      return 2;
    case ContainerTypeStatus.UNRECOGNIZED:
    default:
      return -1;
  }
}

export enum WasteType {
  WASTE_TYPE_UNDEFINED = "WASTE_TYPE_UNDEFINED",
  /** WASTE_TYPE_CONSTRUCTION - СО */
  WASTE_TYPE_CONSTRUCTION = "WASTE_TYPE_CONSTRUCTION",
  /** WASTE_TYPE_MSW - Municipal Solid Waste - ТБО */
  WASTE_TYPE_MSW = "WASTE_TYPE_MSW",
  WASTE_TYPE_LIQUID = "WASTE_TYPE_LIQUID",
  WASTE_TYPE_ORGANIC = "WASTE_TYPE_ORGANIC",
  /** WASTE_TYPE_LOW_DENSITY_POLYETHYLENE - ПНД - полиэтилена низкого давления */
  WASTE_TYPE_LOW_DENSITY_POLYETHYLENE = "WASTE_TYPE_LOW_DENSITY_POLYETHYLENE",
  /** WASTE_TYPE_BULKY - КГМ - крупногабаритный мусор */
  WASTE_TYPE_BULKY = "WASTE_TYPE_BULKY",
  /** WASTE_TYPE_BALLAST - Балласт */
  WASTE_TYPE_BALLAST = "WASTE_TYPE_BALLAST",
  /** WASTE_TYPE_OVERSIZED - Негабарит */
  WASTE_TYPE_OVERSIZED = "WASTE_TYPE_OVERSIZED",
  /** WASTE_TYPE_MIXED - Отходы микс */
  WASTE_TYPE_MIXED = "WASTE_TYPE_MIXED",
  /** WASTE_TYPE_CELLOPHANE - Целлофан */
  WASTE_TYPE_CELLOPHANE = "WASTE_TYPE_CELLOPHANE",
  /** WASTE_TYPE_GLASS_CULLET - Стеклобой */
  WASTE_TYPE_GLASS_CULLET = "WASTE_TYPE_GLASS_CULLET",
  /** WASTE_TYPE_MEDICAL_AND_BIO - Мед и био отходы */
  WASTE_TYPE_MEDICAL_AND_BIO = "WASTE_TYPE_MEDICAL_AND_BIO",
  /** WASTE_TYPE_ALUMINUM_CANS - Алюминиевые банки */
  WASTE_TYPE_ALUMINUM_CANS = "WASTE_TYPE_ALUMINUM_CANS",
  /** WASTE_TYPE_FLAKES - Флейки */
  WASTE_TYPE_FLAKES = "WASTE_TYPE_FLAKES",
  /** WASTE_TYPE_PET - Polyethylene Terephthalate - ПЭТ */
  WASTE_TYPE_PET = "WASTE_TYPE_PET",
  /** WASTE_TYPE_PETRO_PRODUCTS - Fuel and lubricants - ГСМ */
  WASTE_TYPE_PETRO_PRODUCTS = "WASTE_TYPE_PETRO_PRODUCTS",
  /** WASTE_TYPE_PRESSED_MSW - Хвосты */
  WASTE_TYPE_PRESSED_MSW = "WASTE_TYPE_PRESSED_MSW",
  /** WASTE_TYPE_SORTED_MSW - Хвосты росыпь - Not Pressed, but sorted */
  WASTE_TYPE_SORTED_MSW = "WASTE_TYPE_SORTED_MSW",
  /** WASTE_TYPE_NOT_SORTED_MSW - Хвосты росыпь 1 - Not Pressed and not sorted, due to overload */
  WASTE_TYPE_NOT_SORTED_MSW = "WASTE_TYPE_NOT_SORTED_MSW",
  /** WASTE_TYPE_SEPTAGE - Септик | Ассенизатор */
  WASTE_TYPE_SEPTAGE = "WASTE_TYPE_SEPTAGE",
  /** WASTE_TYPE_OVERSIZED_BUNKER - Негабарит бункер */
  WASTE_TYPE_OVERSIZED_BUNKER = "WASTE_TYPE_OVERSIZED_BUNKER",
  /** WASTE_TYPE_SCRAP_METAL - Лом черного металла, Металл, Проволока стальная */
  WASTE_TYPE_SCRAP_METAL = "WASTE_TYPE_SCRAP_METAL",
  /** WASTE_TYPE_PAPER - Макулатура */
  WASTE_TYPE_PAPER = "WASTE_TYPE_PAPER",
  /** WASTE_TYPE_HDPE_FILM - Пленка б/у ПВД */
  WASTE_TYPE_HDPE_FILM = "WASTE_TYPE_HDPE_FILM",
  /** WASTE_TYPE_PP - Мешки ПП, Отходы пластмасс ПП */
  WASTE_TYPE_PP = "WASTE_TYPE_PP",
  /** WASTE_TYPE_TEXTILE - Отходы текстиля */
  WASTE_TYPE_TEXTILE = "WASTE_TYPE_TEXTILE",
  /** WASTE_TYPE_TIRES - Шины */
  WASTE_TYPE_TIRES = "WASTE_TYPE_TIRES",
  /** WASTE_TYPE_LEACHATE - Фильтрат завод */
  WASTE_TYPE_LEACHATE = "WASTE_TYPE_LEACHATE",
  /** WASTE_TYPE_VEHICLE_WEIGHING - Взвешивание ТС */
  WASTE_TYPE_VEHICLE_WEIGHING = "WASTE_TYPE_VEHICLE_WEIGHING",
  /** WASTE_TYPE_HIGH_DENSITY_POLYETHYLENE - ПВД - полиэтилена высокого давления */
  WASTE_TYPE_HIGH_DENSITY_POLYETHYLENE = "WASTE_TYPE_HIGH_DENSITY_POLYETHYLENE",
  /** WASTE_TYPE_DARK_PET_SCRAPS - Лом и отходы из полиэтилентерефталата (Темные) */
  WASTE_TYPE_DARK_PET_SCRAPS = "WASTE_TYPE_DARK_PET_SCRAPS",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function wasteTypeFromJSON(object: any): WasteType {
  switch (object) {
    case 0:
    case "WASTE_TYPE_UNDEFINED":
      return WasteType.WASTE_TYPE_UNDEFINED;
    case 1:
    case "WASTE_TYPE_CONSTRUCTION":
      return WasteType.WASTE_TYPE_CONSTRUCTION;
    case 2:
    case "WASTE_TYPE_MSW":
      return WasteType.WASTE_TYPE_MSW;
    case 3:
    case "WASTE_TYPE_LIQUID":
      return WasteType.WASTE_TYPE_LIQUID;
    case 4:
    case "WASTE_TYPE_ORGANIC":
      return WasteType.WASTE_TYPE_ORGANIC;
    case 5:
    case "WASTE_TYPE_LOW_DENSITY_POLYETHYLENE":
      return WasteType.WASTE_TYPE_LOW_DENSITY_POLYETHYLENE;
    case 6:
    case "WASTE_TYPE_BULKY":
      return WasteType.WASTE_TYPE_BULKY;
    case 7:
    case "WASTE_TYPE_BALLAST":
      return WasteType.WASTE_TYPE_BALLAST;
    case 8:
    case "WASTE_TYPE_OVERSIZED":
      return WasteType.WASTE_TYPE_OVERSIZED;
    case 9:
    case "WASTE_TYPE_MIXED":
      return WasteType.WASTE_TYPE_MIXED;
    case 10:
    case "WASTE_TYPE_CELLOPHANE":
      return WasteType.WASTE_TYPE_CELLOPHANE;
    case 11:
    case "WASTE_TYPE_GLASS_CULLET":
      return WasteType.WASTE_TYPE_GLASS_CULLET;
    case 12:
    case "WASTE_TYPE_MEDICAL_AND_BIO":
      return WasteType.WASTE_TYPE_MEDICAL_AND_BIO;
    case 13:
    case "WASTE_TYPE_ALUMINUM_CANS":
      return WasteType.WASTE_TYPE_ALUMINUM_CANS;
    case 14:
    case "WASTE_TYPE_FLAKES":
      return WasteType.WASTE_TYPE_FLAKES;
    case 15:
    case "WASTE_TYPE_PET":
      return WasteType.WASTE_TYPE_PET;
    case 16:
    case "WASTE_TYPE_PETRO_PRODUCTS":
      return WasteType.WASTE_TYPE_PETRO_PRODUCTS;
    case 17:
    case "WASTE_TYPE_PRESSED_MSW":
      return WasteType.WASTE_TYPE_PRESSED_MSW;
    case 18:
    case "WASTE_TYPE_SORTED_MSW":
      return WasteType.WASTE_TYPE_SORTED_MSW;
    case 19:
    case "WASTE_TYPE_NOT_SORTED_MSW":
      return WasteType.WASTE_TYPE_NOT_SORTED_MSW;
    case 20:
    case "WASTE_TYPE_SEPTAGE":
      return WasteType.WASTE_TYPE_SEPTAGE;
    case 21:
    case "WASTE_TYPE_OVERSIZED_BUNKER":
      return WasteType.WASTE_TYPE_OVERSIZED_BUNKER;
    case 22:
    case "WASTE_TYPE_SCRAP_METAL":
      return WasteType.WASTE_TYPE_SCRAP_METAL;
    case 23:
    case "WASTE_TYPE_PAPER":
      return WasteType.WASTE_TYPE_PAPER;
    case 24:
    case "WASTE_TYPE_HDPE_FILM":
      return WasteType.WASTE_TYPE_HDPE_FILM;
    case 25:
    case "WASTE_TYPE_PP":
      return WasteType.WASTE_TYPE_PP;
    case 26:
    case "WASTE_TYPE_TEXTILE":
      return WasteType.WASTE_TYPE_TEXTILE;
    case 27:
    case "WASTE_TYPE_TIRES":
      return WasteType.WASTE_TYPE_TIRES;
    case 28:
    case "WASTE_TYPE_LEACHATE":
      return WasteType.WASTE_TYPE_LEACHATE;
    case 29:
    case "WASTE_TYPE_VEHICLE_WEIGHING":
      return WasteType.WASTE_TYPE_VEHICLE_WEIGHING;
    case 30:
    case "WASTE_TYPE_HIGH_DENSITY_POLYETHYLENE":
      return WasteType.WASTE_TYPE_HIGH_DENSITY_POLYETHYLENE;
    case 31:
    case "WASTE_TYPE_DARK_PET_SCRAPS":
      return WasteType.WASTE_TYPE_DARK_PET_SCRAPS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return WasteType.UNRECOGNIZED;
  }
}

export function wasteTypeToJSON(object: WasteType): string {
  switch (object) {
    case WasteType.WASTE_TYPE_UNDEFINED:
      return "WASTE_TYPE_UNDEFINED";
    case WasteType.WASTE_TYPE_CONSTRUCTION:
      return "WASTE_TYPE_CONSTRUCTION";
    case WasteType.WASTE_TYPE_MSW:
      return "WASTE_TYPE_MSW";
    case WasteType.WASTE_TYPE_LIQUID:
      return "WASTE_TYPE_LIQUID";
    case WasteType.WASTE_TYPE_ORGANIC:
      return "WASTE_TYPE_ORGANIC";
    case WasteType.WASTE_TYPE_LOW_DENSITY_POLYETHYLENE:
      return "WASTE_TYPE_LOW_DENSITY_POLYETHYLENE";
    case WasteType.WASTE_TYPE_BULKY:
      return "WASTE_TYPE_BULKY";
    case WasteType.WASTE_TYPE_BALLAST:
      return "WASTE_TYPE_BALLAST";
    case WasteType.WASTE_TYPE_OVERSIZED:
      return "WASTE_TYPE_OVERSIZED";
    case WasteType.WASTE_TYPE_MIXED:
      return "WASTE_TYPE_MIXED";
    case WasteType.WASTE_TYPE_CELLOPHANE:
      return "WASTE_TYPE_CELLOPHANE";
    case WasteType.WASTE_TYPE_GLASS_CULLET:
      return "WASTE_TYPE_GLASS_CULLET";
    case WasteType.WASTE_TYPE_MEDICAL_AND_BIO:
      return "WASTE_TYPE_MEDICAL_AND_BIO";
    case WasteType.WASTE_TYPE_ALUMINUM_CANS:
      return "WASTE_TYPE_ALUMINUM_CANS";
    case WasteType.WASTE_TYPE_FLAKES:
      return "WASTE_TYPE_FLAKES";
    case WasteType.WASTE_TYPE_PET:
      return "WASTE_TYPE_PET";
    case WasteType.WASTE_TYPE_PETRO_PRODUCTS:
      return "WASTE_TYPE_PETRO_PRODUCTS";
    case WasteType.WASTE_TYPE_PRESSED_MSW:
      return "WASTE_TYPE_PRESSED_MSW";
    case WasteType.WASTE_TYPE_SORTED_MSW:
      return "WASTE_TYPE_SORTED_MSW";
    case WasteType.WASTE_TYPE_NOT_SORTED_MSW:
      return "WASTE_TYPE_NOT_SORTED_MSW";
    case WasteType.WASTE_TYPE_SEPTAGE:
      return "WASTE_TYPE_SEPTAGE";
    case WasteType.WASTE_TYPE_OVERSIZED_BUNKER:
      return "WASTE_TYPE_OVERSIZED_BUNKER";
    case WasteType.WASTE_TYPE_SCRAP_METAL:
      return "WASTE_TYPE_SCRAP_METAL";
    case WasteType.WASTE_TYPE_PAPER:
      return "WASTE_TYPE_PAPER";
    case WasteType.WASTE_TYPE_HDPE_FILM:
      return "WASTE_TYPE_HDPE_FILM";
    case WasteType.WASTE_TYPE_PP:
      return "WASTE_TYPE_PP";
    case WasteType.WASTE_TYPE_TEXTILE:
      return "WASTE_TYPE_TEXTILE";
    case WasteType.WASTE_TYPE_TIRES:
      return "WASTE_TYPE_TIRES";
    case WasteType.WASTE_TYPE_LEACHATE:
      return "WASTE_TYPE_LEACHATE";
    case WasteType.WASTE_TYPE_VEHICLE_WEIGHING:
      return "WASTE_TYPE_VEHICLE_WEIGHING";
    case WasteType.WASTE_TYPE_HIGH_DENSITY_POLYETHYLENE:
      return "WASTE_TYPE_HIGH_DENSITY_POLYETHYLENE";
    case WasteType.WASTE_TYPE_DARK_PET_SCRAPS:
      return "WASTE_TYPE_DARK_PET_SCRAPS";
    case WasteType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function wasteTypeToNumber(object: WasteType): number {
  switch (object) {
    case WasteType.WASTE_TYPE_UNDEFINED:
      return 0;
    case WasteType.WASTE_TYPE_CONSTRUCTION:
      return 1;
    case WasteType.WASTE_TYPE_MSW:
      return 2;
    case WasteType.WASTE_TYPE_LIQUID:
      return 3;
    case WasteType.WASTE_TYPE_ORGANIC:
      return 4;
    case WasteType.WASTE_TYPE_LOW_DENSITY_POLYETHYLENE:
      return 5;
    case WasteType.WASTE_TYPE_BULKY:
      return 6;
    case WasteType.WASTE_TYPE_BALLAST:
      return 7;
    case WasteType.WASTE_TYPE_OVERSIZED:
      return 8;
    case WasteType.WASTE_TYPE_MIXED:
      return 9;
    case WasteType.WASTE_TYPE_CELLOPHANE:
      return 10;
    case WasteType.WASTE_TYPE_GLASS_CULLET:
      return 11;
    case WasteType.WASTE_TYPE_MEDICAL_AND_BIO:
      return 12;
    case WasteType.WASTE_TYPE_ALUMINUM_CANS:
      return 13;
    case WasteType.WASTE_TYPE_FLAKES:
      return 14;
    case WasteType.WASTE_TYPE_PET:
      return 15;
    case WasteType.WASTE_TYPE_PETRO_PRODUCTS:
      return 16;
    case WasteType.WASTE_TYPE_PRESSED_MSW:
      return 17;
    case WasteType.WASTE_TYPE_SORTED_MSW:
      return 18;
    case WasteType.WASTE_TYPE_NOT_SORTED_MSW:
      return 19;
    case WasteType.WASTE_TYPE_SEPTAGE:
      return 20;
    case WasteType.WASTE_TYPE_OVERSIZED_BUNKER:
      return 21;
    case WasteType.WASTE_TYPE_SCRAP_METAL:
      return 22;
    case WasteType.WASTE_TYPE_PAPER:
      return 23;
    case WasteType.WASTE_TYPE_HDPE_FILM:
      return 24;
    case WasteType.WASTE_TYPE_PP:
      return 25;
    case WasteType.WASTE_TYPE_TEXTILE:
      return 26;
    case WasteType.WASTE_TYPE_TIRES:
      return 27;
    case WasteType.WASTE_TYPE_LEACHATE:
      return 28;
    case WasteType.WASTE_TYPE_VEHICLE_WEIGHING:
      return 29;
    case WasteType.WASTE_TYPE_HIGH_DENSITY_POLYETHYLENE:
      return 30;
    case WasteType.WASTE_TYPE_DARK_PET_SCRAPS:
      return 31;
    case WasteType.UNRECOGNIZED:
    default:
      return -1;
  }
}

/** Where a weighing stands: derived from whether its netto weight is recorded. */
export enum ScaleRecordStatus {
  SCALE_RECORD_STATUS_UNDEFINED = "SCALE_RECORD_STATUS_UNDEFINED",
  /** SCALE_RECORD_STATUS_IN_PROGRESS - Brutto weighed, netto still to come. */
  SCALE_RECORD_STATUS_IN_PROGRESS = "SCALE_RECORD_STATUS_IN_PROGRESS",
  /** SCALE_RECORD_STATUS_COMPLETED - Netto recorded. */
  SCALE_RECORD_STATUS_COMPLETED = "SCALE_RECORD_STATUS_COMPLETED",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function scaleRecordStatusFromJSON(object: any): ScaleRecordStatus {
  switch (object) {
    case 0:
    case "SCALE_RECORD_STATUS_UNDEFINED":
      return ScaleRecordStatus.SCALE_RECORD_STATUS_UNDEFINED;
    case 1:
    case "SCALE_RECORD_STATUS_IN_PROGRESS":
      return ScaleRecordStatus.SCALE_RECORD_STATUS_IN_PROGRESS;
    case 2:
    case "SCALE_RECORD_STATUS_COMPLETED":
      return ScaleRecordStatus.SCALE_RECORD_STATUS_COMPLETED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ScaleRecordStatus.UNRECOGNIZED;
  }
}

export function scaleRecordStatusToJSON(object: ScaleRecordStatus): string {
  switch (object) {
    case ScaleRecordStatus.SCALE_RECORD_STATUS_UNDEFINED:
      return "SCALE_RECORD_STATUS_UNDEFINED";
    case ScaleRecordStatus.SCALE_RECORD_STATUS_IN_PROGRESS:
      return "SCALE_RECORD_STATUS_IN_PROGRESS";
    case ScaleRecordStatus.SCALE_RECORD_STATUS_COMPLETED:
      return "SCALE_RECORD_STATUS_COMPLETED";
    case ScaleRecordStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function scaleRecordStatusToNumber(object: ScaleRecordStatus): number {
  switch (object) {
    case ScaleRecordStatus.SCALE_RECORD_STATUS_UNDEFINED:
      return 0;
    case ScaleRecordStatus.SCALE_RECORD_STATUS_IN_PROGRESS:
      return 1;
    case ScaleRecordStatus.SCALE_RECORD_STATUS_COMPLETED:
      return 2;
    case ScaleRecordStatus.UNRECOGNIZED:
    default:
      return -1;
  }
}

export enum TruckEngineType {
  TRUCK_ENGINE_TYPE_UNDEFINED = "TRUCK_ENGINE_TYPE_UNDEFINED",
  TRUCK_ENGINE_TYPE_DIESEL = "TRUCK_ENGINE_TYPE_DIESEL",
  TRUCK_ENGINE_TYPE_PETROL = "TRUCK_ENGINE_TYPE_PETROL",
  TRUCK_ENGINE_TYPE_ELECTRIC = "TRUCK_ENGINE_TYPE_ELECTRIC",
  TRUCK_ENGINE_TYPE_HYBRID = "TRUCK_ENGINE_TYPE_HYBRID",
  /** TRUCK_ENGINE_TYPE_CNG - Compressed Natural Gas */
  TRUCK_ENGINE_TYPE_CNG = "TRUCK_ENGINE_TYPE_CNG",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function truckEngineTypeFromJSON(object: any): TruckEngineType {
  switch (object) {
    case 0:
    case "TRUCK_ENGINE_TYPE_UNDEFINED":
      return TruckEngineType.TRUCK_ENGINE_TYPE_UNDEFINED;
    case 1:
    case "TRUCK_ENGINE_TYPE_DIESEL":
      return TruckEngineType.TRUCK_ENGINE_TYPE_DIESEL;
    case 2:
    case "TRUCK_ENGINE_TYPE_PETROL":
      return TruckEngineType.TRUCK_ENGINE_TYPE_PETROL;
    case 3:
    case "TRUCK_ENGINE_TYPE_ELECTRIC":
      return TruckEngineType.TRUCK_ENGINE_TYPE_ELECTRIC;
    case 4:
    case "TRUCK_ENGINE_TYPE_HYBRID":
      return TruckEngineType.TRUCK_ENGINE_TYPE_HYBRID;
    case 5:
    case "TRUCK_ENGINE_TYPE_CNG":
      return TruckEngineType.TRUCK_ENGINE_TYPE_CNG;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TruckEngineType.UNRECOGNIZED;
  }
}

export function truckEngineTypeToJSON(object: TruckEngineType): string {
  switch (object) {
    case TruckEngineType.TRUCK_ENGINE_TYPE_UNDEFINED:
      return "TRUCK_ENGINE_TYPE_UNDEFINED";
    case TruckEngineType.TRUCK_ENGINE_TYPE_DIESEL:
      return "TRUCK_ENGINE_TYPE_DIESEL";
    case TruckEngineType.TRUCK_ENGINE_TYPE_PETROL:
      return "TRUCK_ENGINE_TYPE_PETROL";
    case TruckEngineType.TRUCK_ENGINE_TYPE_ELECTRIC:
      return "TRUCK_ENGINE_TYPE_ELECTRIC";
    case TruckEngineType.TRUCK_ENGINE_TYPE_HYBRID:
      return "TRUCK_ENGINE_TYPE_HYBRID";
    case TruckEngineType.TRUCK_ENGINE_TYPE_CNG:
      return "TRUCK_ENGINE_TYPE_CNG";
    case TruckEngineType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function truckEngineTypeToNumber(object: TruckEngineType): number {
  switch (object) {
    case TruckEngineType.TRUCK_ENGINE_TYPE_UNDEFINED:
      return 0;
    case TruckEngineType.TRUCK_ENGINE_TYPE_DIESEL:
      return 1;
    case TruckEngineType.TRUCK_ENGINE_TYPE_PETROL:
      return 2;
    case TruckEngineType.TRUCK_ENGINE_TYPE_ELECTRIC:
      return 3;
    case TruckEngineType.TRUCK_ENGINE_TYPE_HYBRID:
      return 4;
    case TruckEngineType.TRUCK_ENGINE_TYPE_CNG:
      return 5;
    case TruckEngineType.UNRECOGNIZED:
    default:
      return -1;
  }
}

export enum WhatsappOrderStatus {
  WHATSAPP_ORDER_STATUS_UNDEFINED = "WHATSAPP_ORDER_STATUS_UNDEFINED",
  WHATSAPP_ORDER_STATUS_WELCOME = "WHATSAPP_ORDER_STATUS_WELCOME",
  WHATSAPP_ORDER_STATUS_SELECTING_GROUP = "WHATSAPP_ORDER_STATUS_SELECTING_GROUP",
  WHATSAPP_ORDER_STATUS_SELECTING_JOB_TYPE = "WHATSAPP_ORDER_STATUS_SELECTING_JOB_TYPE",
  WHATSAPP_ORDER_STATUS_PENDING = "WHATSAPP_ORDER_STATUS_PENDING",
  WHATSAPP_ORDER_STATUS_CONFIRMED = "WHATSAPP_ORDER_STATUS_CONFIRMED",
  WHATSAPP_ORDER_STATUS_CANCELLED = "WHATSAPP_ORDER_STATUS_CANCELLED",
  WHATSAPP_ORDER_STATUS_EXPIRED = "WHATSAPP_ORDER_STATUS_EXPIRED",
  /**
   * WHATSAPP_ORDER_STATUS_AWAITING_COMMENT - Job type is fixed; the sender is asked for an optional comment for the
   * driver (how to enter the site, where the containers stand, ...) before
   * the confirmation prompt.
   */
  WHATSAPP_ORDER_STATUS_AWAITING_COMMENT = "WHATSAPP_ORDER_STATUS_AWAITING_COMMENT",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function whatsappOrderStatusFromJSON(object: any): WhatsappOrderStatus {
  switch (object) {
    case 0:
    case "WHATSAPP_ORDER_STATUS_UNDEFINED":
      return WhatsappOrderStatus.WHATSAPP_ORDER_STATUS_UNDEFINED;
    case 1:
    case "WHATSAPP_ORDER_STATUS_WELCOME":
      return WhatsappOrderStatus.WHATSAPP_ORDER_STATUS_WELCOME;
    case 2:
    case "WHATSAPP_ORDER_STATUS_SELECTING_GROUP":
      return WhatsappOrderStatus.WHATSAPP_ORDER_STATUS_SELECTING_GROUP;
    case 3:
    case "WHATSAPP_ORDER_STATUS_SELECTING_JOB_TYPE":
      return WhatsappOrderStatus.WHATSAPP_ORDER_STATUS_SELECTING_JOB_TYPE;
    case 4:
    case "WHATSAPP_ORDER_STATUS_PENDING":
      return WhatsappOrderStatus.WHATSAPP_ORDER_STATUS_PENDING;
    case 5:
    case "WHATSAPP_ORDER_STATUS_CONFIRMED":
      return WhatsappOrderStatus.WHATSAPP_ORDER_STATUS_CONFIRMED;
    case 6:
    case "WHATSAPP_ORDER_STATUS_CANCELLED":
      return WhatsappOrderStatus.WHATSAPP_ORDER_STATUS_CANCELLED;
    case 7:
    case "WHATSAPP_ORDER_STATUS_EXPIRED":
      return WhatsappOrderStatus.WHATSAPP_ORDER_STATUS_EXPIRED;
    case 8:
    case "WHATSAPP_ORDER_STATUS_AWAITING_COMMENT":
      return WhatsappOrderStatus.WHATSAPP_ORDER_STATUS_AWAITING_COMMENT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return WhatsappOrderStatus.UNRECOGNIZED;
  }
}

export function whatsappOrderStatusToJSON(object: WhatsappOrderStatus): string {
  switch (object) {
    case WhatsappOrderStatus.WHATSAPP_ORDER_STATUS_UNDEFINED:
      return "WHATSAPP_ORDER_STATUS_UNDEFINED";
    case WhatsappOrderStatus.WHATSAPP_ORDER_STATUS_WELCOME:
      return "WHATSAPP_ORDER_STATUS_WELCOME";
    case WhatsappOrderStatus.WHATSAPP_ORDER_STATUS_SELECTING_GROUP:
      return "WHATSAPP_ORDER_STATUS_SELECTING_GROUP";
    case WhatsappOrderStatus.WHATSAPP_ORDER_STATUS_SELECTING_JOB_TYPE:
      return "WHATSAPP_ORDER_STATUS_SELECTING_JOB_TYPE";
    case WhatsappOrderStatus.WHATSAPP_ORDER_STATUS_PENDING:
      return "WHATSAPP_ORDER_STATUS_PENDING";
    case WhatsappOrderStatus.WHATSAPP_ORDER_STATUS_CONFIRMED:
      return "WHATSAPP_ORDER_STATUS_CONFIRMED";
    case WhatsappOrderStatus.WHATSAPP_ORDER_STATUS_CANCELLED:
      return "WHATSAPP_ORDER_STATUS_CANCELLED";
    case WhatsappOrderStatus.WHATSAPP_ORDER_STATUS_EXPIRED:
      return "WHATSAPP_ORDER_STATUS_EXPIRED";
    case WhatsappOrderStatus.WHATSAPP_ORDER_STATUS_AWAITING_COMMENT:
      return "WHATSAPP_ORDER_STATUS_AWAITING_COMMENT";
    case WhatsappOrderStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function whatsappOrderStatusToNumber(object: WhatsappOrderStatus): number {
  switch (object) {
    case WhatsappOrderStatus.WHATSAPP_ORDER_STATUS_UNDEFINED:
      return 0;
    case WhatsappOrderStatus.WHATSAPP_ORDER_STATUS_WELCOME:
      return 1;
    case WhatsappOrderStatus.WHATSAPP_ORDER_STATUS_SELECTING_GROUP:
      return 2;
    case WhatsappOrderStatus.WHATSAPP_ORDER_STATUS_SELECTING_JOB_TYPE:
      return 3;
    case WhatsappOrderStatus.WHATSAPP_ORDER_STATUS_PENDING:
      return 4;
    case WhatsappOrderStatus.WHATSAPP_ORDER_STATUS_CONFIRMED:
      return 5;
    case WhatsappOrderStatus.WHATSAPP_ORDER_STATUS_CANCELLED:
      return 6;
    case WhatsappOrderStatus.WHATSAPP_ORDER_STATUS_EXPIRED:
      return 7;
    case WhatsappOrderStatus.WHATSAPP_ORDER_STATUS_AWAITING_COMMENT:
      return 8;
    case WhatsappOrderStatus.UNRECOGNIZED:
    default:
      return -1;
  }
}

/**
 * Which telemetry a Моточасы (engine active hours) figure was derived from. Exposed so a
 * consumer can tell a measured figure from an absent one instead of reading 0 as "idle".
 */
export enum EngineHoursSource {
  ENGINE_HOURS_SOURCE_UNDEFINED = "ENGINE_HOURS_SOURCE_UNDEFINED",
  /**
   * ENGINE_HOURS_SOURCE_IGNITION - Integral of the ignition/engine-operation sensor over the shift window. Fleet-wide on
   * the Wialon Local orgs, and the preferred source.
   */
  ENGINE_HOURS_SOURCE_IGNITION = "ENGINE_HOURS_SOURCE_IGNITION",
  /**
   * ENGINE_HOURS_SOURCE_CAN_COUNTER - Span of the cumulative CAN total_engine_hours counter. Only a handful of trucks carry a
   * genuine hour meter.
   */
  ENGINE_HOURS_SOURCE_CAN_COUNTER = "ENGINE_HOURS_SOURCE_CAN_COUNTER",
  /** ENGINE_HOURS_SOURCE_NONE - The shift has a window but no usable engine telemetry in it. */
  ENGINE_HOURS_SOURCE_NONE = "ENGINE_HOURS_SOURCE_NONE",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function engineHoursSourceFromJSON(object: any): EngineHoursSource {
  switch (object) {
    case 0:
    case "ENGINE_HOURS_SOURCE_UNDEFINED":
      return EngineHoursSource.ENGINE_HOURS_SOURCE_UNDEFINED;
    case 1:
    case "ENGINE_HOURS_SOURCE_IGNITION":
      return EngineHoursSource.ENGINE_HOURS_SOURCE_IGNITION;
    case 2:
    case "ENGINE_HOURS_SOURCE_CAN_COUNTER":
      return EngineHoursSource.ENGINE_HOURS_SOURCE_CAN_COUNTER;
    case 3:
    case "ENGINE_HOURS_SOURCE_NONE":
      return EngineHoursSource.ENGINE_HOURS_SOURCE_NONE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return EngineHoursSource.UNRECOGNIZED;
  }
}

export function engineHoursSourceToJSON(object: EngineHoursSource): string {
  switch (object) {
    case EngineHoursSource.ENGINE_HOURS_SOURCE_UNDEFINED:
      return "ENGINE_HOURS_SOURCE_UNDEFINED";
    case EngineHoursSource.ENGINE_HOURS_SOURCE_IGNITION:
      return "ENGINE_HOURS_SOURCE_IGNITION";
    case EngineHoursSource.ENGINE_HOURS_SOURCE_CAN_COUNTER:
      return "ENGINE_HOURS_SOURCE_CAN_COUNTER";
    case EngineHoursSource.ENGINE_HOURS_SOURCE_NONE:
      return "ENGINE_HOURS_SOURCE_NONE";
    case EngineHoursSource.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function engineHoursSourceToNumber(object: EngineHoursSource): number {
  switch (object) {
    case EngineHoursSource.ENGINE_HOURS_SOURCE_UNDEFINED:
      return 0;
    case EngineHoursSource.ENGINE_HOURS_SOURCE_IGNITION:
      return 1;
    case EngineHoursSource.ENGINE_HOURS_SOURCE_CAN_COUNTER:
      return 2;
    case EngineHoursSource.ENGINE_HOURS_SOURCE_NONE:
      return 3;
    case EngineHoursSource.UNRECOGNIZED:
    default:
      return -1;
  }
}

/**
 * What a WhatsApp history message carries. Only text for now; polls, button
 * messages and other kinds come as new values.
 */
export enum WhatsappMessageKind {
  WHATSAPP_MESSAGE_KIND_UNDEFINED = "WHATSAPP_MESSAGE_KIND_UNDEFINED",
  WHATSAPP_MESSAGE_KIND_TEXT = "WHATSAPP_MESSAGE_KIND_TEXT",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function whatsappMessageKindFromJSON(object: any): WhatsappMessageKind {
  switch (object) {
    case 0:
    case "WHATSAPP_MESSAGE_KIND_UNDEFINED":
      return WhatsappMessageKind.WHATSAPP_MESSAGE_KIND_UNDEFINED;
    case 1:
    case "WHATSAPP_MESSAGE_KIND_TEXT":
      return WhatsappMessageKind.WHATSAPP_MESSAGE_KIND_TEXT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return WhatsappMessageKind.UNRECOGNIZED;
  }
}

export function whatsappMessageKindToJSON(object: WhatsappMessageKind): string {
  switch (object) {
    case WhatsappMessageKind.WHATSAPP_MESSAGE_KIND_UNDEFINED:
      return "WHATSAPP_MESSAGE_KIND_UNDEFINED";
    case WhatsappMessageKind.WHATSAPP_MESSAGE_KIND_TEXT:
      return "WHATSAPP_MESSAGE_KIND_TEXT";
    case WhatsappMessageKind.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function whatsappMessageKindToNumber(object: WhatsappMessageKind): number {
  switch (object) {
    case WhatsappMessageKind.WHATSAPP_MESSAGE_KIND_UNDEFINED:
      return 0;
    case WhatsappMessageKind.WHATSAPP_MESSAGE_KIND_TEXT:
      return 1;
    case WhatsappMessageKind.UNRECOGNIZED:
    default:
      return -1;
  }
}

/**
 * Delivery of a dispatcher's message, from the send and Meta's status webhooks.
 * Numbered in delivery order: a message only moves forward. Unset on inbound
 * and bot messages.
 */
export enum WhatsappMessageStatus {
  WHATSAPP_MESSAGE_STATUS_UNDEFINED = "WHATSAPP_MESSAGE_STATUS_UNDEFINED",
  WHATSAPP_MESSAGE_STATUS_SENT = "WHATSAPP_MESSAGE_STATUS_SENT",
  WHATSAPP_MESSAGE_STATUS_DELIVERED = "WHATSAPP_MESSAGE_STATUS_DELIVERED",
  WHATSAPP_MESSAGE_STATUS_READ = "WHATSAPP_MESSAGE_STATUS_READ",
  /** WHATSAPP_MESSAGE_STATUS_FAILED - Refused at send time or failed later (e.g. outside the 24h window). */
  WHATSAPP_MESSAGE_STATUS_FAILED = "WHATSAPP_MESSAGE_STATUS_FAILED",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function whatsappMessageStatusFromJSON(object: any): WhatsappMessageStatus {
  switch (object) {
    case 0:
    case "WHATSAPP_MESSAGE_STATUS_UNDEFINED":
      return WhatsappMessageStatus.WHATSAPP_MESSAGE_STATUS_UNDEFINED;
    case 1:
    case "WHATSAPP_MESSAGE_STATUS_SENT":
      return WhatsappMessageStatus.WHATSAPP_MESSAGE_STATUS_SENT;
    case 2:
    case "WHATSAPP_MESSAGE_STATUS_DELIVERED":
      return WhatsappMessageStatus.WHATSAPP_MESSAGE_STATUS_DELIVERED;
    case 3:
    case "WHATSAPP_MESSAGE_STATUS_READ":
      return WhatsappMessageStatus.WHATSAPP_MESSAGE_STATUS_READ;
    case 4:
    case "WHATSAPP_MESSAGE_STATUS_FAILED":
      return WhatsappMessageStatus.WHATSAPP_MESSAGE_STATUS_FAILED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return WhatsappMessageStatus.UNRECOGNIZED;
  }
}

export function whatsappMessageStatusToJSON(object: WhatsappMessageStatus): string {
  switch (object) {
    case WhatsappMessageStatus.WHATSAPP_MESSAGE_STATUS_UNDEFINED:
      return "WHATSAPP_MESSAGE_STATUS_UNDEFINED";
    case WhatsappMessageStatus.WHATSAPP_MESSAGE_STATUS_SENT:
      return "WHATSAPP_MESSAGE_STATUS_SENT";
    case WhatsappMessageStatus.WHATSAPP_MESSAGE_STATUS_DELIVERED:
      return "WHATSAPP_MESSAGE_STATUS_DELIVERED";
    case WhatsappMessageStatus.WHATSAPP_MESSAGE_STATUS_READ:
      return "WHATSAPP_MESSAGE_STATUS_READ";
    case WhatsappMessageStatus.WHATSAPP_MESSAGE_STATUS_FAILED:
      return "WHATSAPP_MESSAGE_STATUS_FAILED";
    case WhatsappMessageStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function whatsappMessageStatusToNumber(object: WhatsappMessageStatus): number {
  switch (object) {
    case WhatsappMessageStatus.WHATSAPP_MESSAGE_STATUS_UNDEFINED:
      return 0;
    case WhatsappMessageStatus.WHATSAPP_MESSAGE_STATUS_SENT:
      return 1;
    case WhatsappMessageStatus.WHATSAPP_MESSAGE_STATUS_DELIVERED:
      return 2;
    case WhatsappMessageStatus.WHATSAPP_MESSAGE_STATUS_READ:
      return 3;
    case WhatsappMessageStatus.WHATSAPP_MESSAGE_STATUS_FAILED:
      return 4;
    case WhatsappMessageStatus.UNRECOGNIZED:
    default:
      return -1;
  }
}

/**
 * Kind of an accounting document a provider's accounting system (1C) reports
 * back for the jobs it billed.
 */
export enum AccountingDocumentKind {
  ACCOUNTING_DOCUMENT_KIND_UNDEFINED = "ACCOUNTING_DOCUMENT_KIND_UNDEFINED",
  /** ACCOUNTING_DOCUMENT_KIND_REALIZATION - «Реализация ТМЗ и услуг»: the sales document the act and the invoice are printed from. */
  ACCOUNTING_DOCUMENT_KIND_REALIZATION = "ACCOUNTING_DOCUMENT_KIND_REALIZATION",
  /** ACCOUNTING_DOCUMENT_KIND_ACT - АВР: act of completed works. */
  ACCOUNTING_DOCUMENT_KIND_ACT = "ACCOUNTING_DOCUMENT_KIND_ACT",
  /** ACCOUNTING_DOCUMENT_KIND_ESF - ЭСФ: electronic tax invoice (ИС ЭСФ). */
  ACCOUNTING_DOCUMENT_KIND_ESF = "ACCOUNTING_DOCUMENT_KIND_ESF",
  /** ACCOUNTING_DOCUMENT_KIND_INVOICE - Счёт на оплату: payment request. */
  ACCOUNTING_DOCUMENT_KIND_INVOICE = "ACCOUNTING_DOCUMENT_KIND_INVOICE",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function accountingDocumentKindFromJSON(object: any): AccountingDocumentKind {
  switch (object) {
    case 0:
    case "ACCOUNTING_DOCUMENT_KIND_UNDEFINED":
      return AccountingDocumentKind.ACCOUNTING_DOCUMENT_KIND_UNDEFINED;
    case 1:
    case "ACCOUNTING_DOCUMENT_KIND_REALIZATION":
      return AccountingDocumentKind.ACCOUNTING_DOCUMENT_KIND_REALIZATION;
    case 2:
    case "ACCOUNTING_DOCUMENT_KIND_ACT":
      return AccountingDocumentKind.ACCOUNTING_DOCUMENT_KIND_ACT;
    case 3:
    case "ACCOUNTING_DOCUMENT_KIND_ESF":
      return AccountingDocumentKind.ACCOUNTING_DOCUMENT_KIND_ESF;
    case 4:
    case "ACCOUNTING_DOCUMENT_KIND_INVOICE":
      return AccountingDocumentKind.ACCOUNTING_DOCUMENT_KIND_INVOICE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AccountingDocumentKind.UNRECOGNIZED;
  }
}

export function accountingDocumentKindToJSON(object: AccountingDocumentKind): string {
  switch (object) {
    case AccountingDocumentKind.ACCOUNTING_DOCUMENT_KIND_UNDEFINED:
      return "ACCOUNTING_DOCUMENT_KIND_UNDEFINED";
    case AccountingDocumentKind.ACCOUNTING_DOCUMENT_KIND_REALIZATION:
      return "ACCOUNTING_DOCUMENT_KIND_REALIZATION";
    case AccountingDocumentKind.ACCOUNTING_DOCUMENT_KIND_ACT:
      return "ACCOUNTING_DOCUMENT_KIND_ACT";
    case AccountingDocumentKind.ACCOUNTING_DOCUMENT_KIND_ESF:
      return "ACCOUNTING_DOCUMENT_KIND_ESF";
    case AccountingDocumentKind.ACCOUNTING_DOCUMENT_KIND_INVOICE:
      return "ACCOUNTING_DOCUMENT_KIND_INVOICE";
    case AccountingDocumentKind.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function accountingDocumentKindToNumber(object: AccountingDocumentKind): number {
  switch (object) {
    case AccountingDocumentKind.ACCOUNTING_DOCUMENT_KIND_UNDEFINED:
      return 0;
    case AccountingDocumentKind.ACCOUNTING_DOCUMENT_KIND_REALIZATION:
      return 1;
    case AccountingDocumentKind.ACCOUNTING_DOCUMENT_KIND_ACT:
      return 2;
    case AccountingDocumentKind.ACCOUNTING_DOCUMENT_KIND_ESF:
      return 3;
    case AccountingDocumentKind.ACCOUNTING_DOCUMENT_KIND_INVOICE:
      return 4;
    case AccountingDocumentKind.UNRECOGNIZED:
    default:
      return -1;
  }
}

/** Lifecycle of an accounting document as the accounting system reports it. */
export enum AccountingDocumentStatus {
  ACCOUNTING_DOCUMENT_STATUS_UNDEFINED = "ACCOUNTING_DOCUMENT_STATUS_UNDEFINED",
  /** ACCOUNTING_DOCUMENT_STATUS_DRAFT - created, not posted */
  ACCOUNTING_DOCUMENT_STATUS_DRAFT = "ACCOUNTING_DOCUMENT_STATUS_DRAFT",
  /** ACCOUNTING_DOCUMENT_STATUS_POSTED - проведён */
  ACCOUNTING_DOCUMENT_STATUS_POSTED = "ACCOUNTING_DOCUMENT_STATUS_POSTED",
  /** ACCOUNTING_DOCUMENT_STATUS_SENT - sent to the counterparty or to ИС ЭСФ */
  ACCOUNTING_DOCUMENT_STATUS_SENT = "ACCOUNTING_DOCUMENT_STATUS_SENT",
  /** ACCOUNTING_DOCUMENT_STATUS_SIGNED - accepted by the counterparty */
  ACCOUNTING_DOCUMENT_STATUS_SIGNED = "ACCOUNTING_DOCUMENT_STATUS_SIGNED",
  ACCOUNTING_DOCUMENT_STATUS_REJECTED = "ACCOUNTING_DOCUMENT_STATUS_REJECTED",
  ACCOUNTING_DOCUMENT_STATUS_CANCELLED = "ACCOUNTING_DOCUMENT_STATUS_CANCELLED",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function accountingDocumentStatusFromJSON(object: any): AccountingDocumentStatus {
  switch (object) {
    case 0:
    case "ACCOUNTING_DOCUMENT_STATUS_UNDEFINED":
      return AccountingDocumentStatus.ACCOUNTING_DOCUMENT_STATUS_UNDEFINED;
    case 1:
    case "ACCOUNTING_DOCUMENT_STATUS_DRAFT":
      return AccountingDocumentStatus.ACCOUNTING_DOCUMENT_STATUS_DRAFT;
    case 2:
    case "ACCOUNTING_DOCUMENT_STATUS_POSTED":
      return AccountingDocumentStatus.ACCOUNTING_DOCUMENT_STATUS_POSTED;
    case 3:
    case "ACCOUNTING_DOCUMENT_STATUS_SENT":
      return AccountingDocumentStatus.ACCOUNTING_DOCUMENT_STATUS_SENT;
    case 4:
    case "ACCOUNTING_DOCUMENT_STATUS_SIGNED":
      return AccountingDocumentStatus.ACCOUNTING_DOCUMENT_STATUS_SIGNED;
    case 5:
    case "ACCOUNTING_DOCUMENT_STATUS_REJECTED":
      return AccountingDocumentStatus.ACCOUNTING_DOCUMENT_STATUS_REJECTED;
    case 6:
    case "ACCOUNTING_DOCUMENT_STATUS_CANCELLED":
      return AccountingDocumentStatus.ACCOUNTING_DOCUMENT_STATUS_CANCELLED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AccountingDocumentStatus.UNRECOGNIZED;
  }
}

export function accountingDocumentStatusToJSON(object: AccountingDocumentStatus): string {
  switch (object) {
    case AccountingDocumentStatus.ACCOUNTING_DOCUMENT_STATUS_UNDEFINED:
      return "ACCOUNTING_DOCUMENT_STATUS_UNDEFINED";
    case AccountingDocumentStatus.ACCOUNTING_DOCUMENT_STATUS_DRAFT:
      return "ACCOUNTING_DOCUMENT_STATUS_DRAFT";
    case AccountingDocumentStatus.ACCOUNTING_DOCUMENT_STATUS_POSTED:
      return "ACCOUNTING_DOCUMENT_STATUS_POSTED";
    case AccountingDocumentStatus.ACCOUNTING_DOCUMENT_STATUS_SENT:
      return "ACCOUNTING_DOCUMENT_STATUS_SENT";
    case AccountingDocumentStatus.ACCOUNTING_DOCUMENT_STATUS_SIGNED:
      return "ACCOUNTING_DOCUMENT_STATUS_SIGNED";
    case AccountingDocumentStatus.ACCOUNTING_DOCUMENT_STATUS_REJECTED:
      return "ACCOUNTING_DOCUMENT_STATUS_REJECTED";
    case AccountingDocumentStatus.ACCOUNTING_DOCUMENT_STATUS_CANCELLED:
      return "ACCOUNTING_DOCUMENT_STATUS_CANCELLED";
    case AccountingDocumentStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function accountingDocumentStatusToNumber(object: AccountingDocumentStatus): number {
  switch (object) {
    case AccountingDocumentStatus.ACCOUNTING_DOCUMENT_STATUS_UNDEFINED:
      return 0;
    case AccountingDocumentStatus.ACCOUNTING_DOCUMENT_STATUS_DRAFT:
      return 1;
    case AccountingDocumentStatus.ACCOUNTING_DOCUMENT_STATUS_POSTED:
      return 2;
    case AccountingDocumentStatus.ACCOUNTING_DOCUMENT_STATUS_SENT:
      return 3;
    case AccountingDocumentStatus.ACCOUNTING_DOCUMENT_STATUS_SIGNED:
      return 4;
    case AccountingDocumentStatus.ACCOUNTING_DOCUMENT_STATUS_REJECTED:
      return 5;
    case AccountingDocumentStatus.ACCOUNTING_DOCUMENT_STATUS_CANCELLED:
      return 6;
    case AccountingDocumentStatus.UNRECOGNIZED:
    default:
      return -1;
  }
}

/** Platform entity an external system keeps its own reference for. */
export enum IntegrationEntityType {
  INTEGRATION_ENTITY_TYPE_UNDEFINED = "INTEGRATION_ENTITY_TYPE_UNDEFINED",
  INTEGRATION_ENTITY_TYPE_ORGANIZATION = "INTEGRATION_ENTITY_TYPE_ORGANIZATION",
  INTEGRATION_ENTITY_TYPE_CONTRACT = "INTEGRATION_ENTITY_TYPE_CONTRACT",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function integrationEntityTypeFromJSON(object: any): IntegrationEntityType {
  switch (object) {
    case 0:
    case "INTEGRATION_ENTITY_TYPE_UNDEFINED":
      return IntegrationEntityType.INTEGRATION_ENTITY_TYPE_UNDEFINED;
    case 1:
    case "INTEGRATION_ENTITY_TYPE_ORGANIZATION":
      return IntegrationEntityType.INTEGRATION_ENTITY_TYPE_ORGANIZATION;
    case 2:
    case "INTEGRATION_ENTITY_TYPE_CONTRACT":
      return IntegrationEntityType.INTEGRATION_ENTITY_TYPE_CONTRACT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return IntegrationEntityType.UNRECOGNIZED;
  }
}

export function integrationEntityTypeToJSON(object: IntegrationEntityType): string {
  switch (object) {
    case IntegrationEntityType.INTEGRATION_ENTITY_TYPE_UNDEFINED:
      return "INTEGRATION_ENTITY_TYPE_UNDEFINED";
    case IntegrationEntityType.INTEGRATION_ENTITY_TYPE_ORGANIZATION:
      return "INTEGRATION_ENTITY_TYPE_ORGANIZATION";
    case IntegrationEntityType.INTEGRATION_ENTITY_TYPE_CONTRACT:
      return "INTEGRATION_ENTITY_TYPE_CONTRACT";
    case IntegrationEntityType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function integrationEntityTypeToNumber(object: IntegrationEntityType): number {
  switch (object) {
    case IntegrationEntityType.INTEGRATION_ENTITY_TYPE_UNDEFINED:
      return 0;
    case IntegrationEntityType.INTEGRATION_ENTITY_TYPE_ORGANIZATION:
      return 1;
    case IntegrationEntityType.INTEGRATION_ENTITY_TYPE_CONTRACT:
      return 2;
    case IntegrationEntityType.UNRECOGNIZED:
    default:
      return -1;
  }
}
